document.documentElement.classList.add('mifoa-js');

if (window.location.pathname.replace(/\/+$/, '') === '/products/mfw-pj-7r4d2') {
  window.location.replace('/products/wixo');
}

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function initializeMifoaReveals(root = document) {
  const elements = root.querySelectorAll('[data-mf-reveal]:not([data-mf-reveal-ready])');

  if (!elements.length) return;

  if (prefersReducedMotion.matches || !('IntersectionObserver' in window)) {
    elements.forEach((element) => {
      element.dataset.mfRevealReady = 'true';
      element.classList.add('is-visible');
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.06, rootMargin: '0px 0px -5% 0px' },
  );

  elements.forEach((element) => {
    element.dataset.mfRevealReady = 'true';
    observer.observe(element);
  });

  window.setTimeout(() => {
    elements.forEach((element) => element.classList.add('is-visible'));
  }, 1200);
}

function initializeMifoaHero(root = document) {
  root.querySelectorAll('[data-mf-hero]').forEach((hero) => {
    if (hero.dataset.mfHeroReady) return;
    hero.dataset.mfHeroReady = 'true';

    const media = hero.querySelector('[data-mf-hero-image]');
    const code = hero.querySelector('[data-mf-hero-code]');
    const description = hero.querySelector('[data-mf-hero-description]');

    hero.querySelectorAll('[data-mf-hero-option]').forEach((option) => {
      option.addEventListener('click', () => {
        hero.querySelectorAll('[data-mf-hero-option]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === option));
        });

        if (media && option.dataset.image) media.src = option.dataset.image;
        if (code) code.textContent = option.dataset.code || '';
        if (description) description.textContent = option.dataset.description || '';
      });
    });
  });
}

// mifoa YOWL sound demo — ported 1:1 from the design's interaction logic:
// clicking a pull chip (or the play overlay) cycles captions within the
// short|long set, advances the progress dots to the global index, and
// restarts the waveform animation for 1.5s. Reduced-motion safe.
function initializeSoundDemo(root = document) {
  const DEFAULT_CAPTIONS = {
    short: [
      'SOUND 01 / 06 — a quick, startled yip',
      'SOUND 02 / 06 — a cartoonish squeak',
      'SOUND 03 / 06 — a grumpy little huff',
    ],
    long: [
      'SOUND 04 / 06 — a long, dramatic wail',
      'SOUND 05 / 06 — an operatic shriek',
      'SOUND 06 / 06 — a wobbling howl',
    ],
  };

  root.querySelectorAll('[data-demo-caption]:not([data-sound-ready])').forEach((caption) => {
    const scope = caption.closest('.mf-source-layout') || caption.closest('.mf-editable-module') || caption.parentElement;
    if (!scope) return;
    const soundButtons = scope.querySelectorAll('[data-sound]');
    if (!soundButtons.length) return; // only YOWL-style demos have named sounds
    caption.dataset.soundReady = 'true';

    const wave = scope.querySelector('[data-wave]');
    const dots = scope.querySelectorAll('[data-dot]');
    const parseCaptions = (attr, fallback) => {
      if (!attr) return fallback;
      try {
        const parsed = JSON.parse(attr);
        return Array.isArray(parsed) && parsed.length ? parsed : fallback;
      } catch (_error) {
        return fallback;
      }
    };
    const captions = {
      short: parseCaptions(scope.dataset.captionsShort, DEFAULT_CAPTIONS.short),
      long: parseCaptions(scope.dataset.captionsLong, DEFAULT_CAPTIONS.long),
    };

    let idx = 0;
    const play = (kind) => {
      if (!captions[kind]) return;
      soundButtons.forEach((button) => {
        const on = button.getAttribute('data-sound') === kind;
        button.style.background = on ? '#3B49BE' : 'transparent';
        button.style.color = on ? '#fff' : '#C9CEDC';
        button.style.borderColor = on ? '#3B49BE' : '#3A3F4E';
        button.style.borderWidth = on ? '1.5px' : '1px';
      });
      const list = captions[kind];
      idx = (idx + 1) % list.length;
      const globalIndex = kind === 'short' ? idx : 3 + idx;
      dots.forEach((dot) => {
        const filled = parseInt(dot.getAttribute('data-dot'), 10) <= globalIndex;
        dot.style.background = filled ? (kind === 'long' ? '#E3A233' : '#3B49BE') : '#2A2E3C';
      });
      caption.textContent = list[idx];
      if (wave && !prefersReducedMotion.matches) {
        wave.classList.remove('playing');
        void wave.offsetWidth;
        wave.classList.add('playing');
        window.setTimeout(() => wave.classList.remove('playing'), 1500);
      }
    };

    soundButtons.forEach((button) => {
      button.addEventListener('click', () => play(button.getAttribute('data-sound')));
    });
    const demoPlay = scope.querySelector('[data-demo-play]');
    if (demoPlay) demoPlay.addEventListener('click', () => play('short'));
  });
}

// mifoa MOXI bubble game — ported from the design's MOXI interaction logic:
// Blow bubbles (start/stop, spawn every 560ms), click a bubble to catch (sparkle),
// Clear resets. Ambient idle stream when not playing. Reduced-motion safe.
function initializeMoxiGame(root = document) {
  const reduce = prefersReducedMotion.matches;
  const HUES = ['#FF6BAA', '#7AA8FF', '#B98CFF', '#E3A233', '#4FD6C7'];

  root.querySelectorAll('[data-moxi-stage]:not([data-moxi-ready])').forEach((stage) => {
    stage.dataset.moxiReady = 'true';
    const scope = stage.closest('.mf-source-layout') || stage.closest('.mf-editable-module') || stage.parentElement;
    if (!scope) return;
    const go = scope.querySelector('[data-moxi-go]');
    const reset = scope.querySelector('[data-moxi-reset]');
    const blownEl = scope.querySelector('[data-moxi-blown]');
    const caughtEl = scope.querySelector('[data-moxi-caught]');
    const music = scope.querySelector('[data-moxi-music]');
    const wand = scope.querySelector('[data-moxi-wandglow]');
    const hint = scope.querySelector('[data-moxi-hint]');
    const layer = stage.querySelector('[data-moxi-layer]') || stage;
    if (layer) layer.style.pointerEvents = 'none';

    let blown = 0;
    let caught = 0;
    let playing = false;
    let timer = null;

    const startLabelNode = go ? [...go.childNodes].reverse().find((n) => n.nodeType === 3 && n.textContent.trim()) : null;
    const startLabel = startLabelNode ? startLabelNode.textContent.trim() : 'Blow bubbles';
    const setLabel = (txt) => { if (startLabelNode) startLabelNode.textContent = ' ' + txt; };
    const setBlown = () => { if (blownEl) blownEl.textContent = String(blown); };
    const setCaught = () => {
      if (!caughtEl) return;
      caughtEl.textContent = String(caught);
      caughtEl.style.transform = 'scale(1.18)';
      window.setTimeout(() => { caughtEl.style.transform = ''; }, 180);
    };

    const sparkle = (x, y, hue) => {
      for (let i = 0; i < 6; i += 1) {
        const dot = document.createElement('span');
        const ang = (Math.PI * 2 * i) / 6;
        dot.className = 'mfSpark';
        dot.style.cssText = `left:${x}px;top:${y}px;background:${hue};--sx:${Math.cos(ang) * 26}px;--sy:${Math.sin(ang) * 26}px;`;
        layer.appendChild(dot);
        window.setTimeout(() => dot.remove(), 460);
      }
    };

    const makeBubble = (idle) => {
      const size = idle ? (28 + Math.random() * 24) : (34 + Math.random() * 40);
      const left = 16 + Math.random() * 68;
      const hue = HUES[Math.floor(Math.random() * HUES.length)];
      const b = document.createElement('span');
      b.className = 'mfBubble';
      b.style.cssText = `position:absolute;left:${left}%;width:${size}px;height:${size}px;border-radius:50%;pointer-events:auto;cursor:pointer;background:radial-gradient(circle at 32% 28%, rgba(255,255,255,.92), ${hue} 62%, rgba(255,255,255,.12));box-shadow:0 0 12px ${hue}66;opacity:${idle ? '0.4' : '0.85'};`;
      if (reduce) {
        b.style.bottom = `${20 + Math.random() * 60}%`;
        b.style.transition = 'opacity 3.6s linear';
        window.requestAnimationFrame(() => { b.style.opacity = '0'; });
        window.setTimeout(() => b.remove(), 3800);
      } else {
        const dur = idle ? (9 + Math.random() * 3) : (6 + Math.random() * 3);
        const drift = Math.random() * 130 - 65;
        b.style.bottom = '-80px';
        b.style.setProperty('--mf-drift', `${drift}px`);
        b.style.animation = `mfBubbleUp ${dur}s linear forwards`;
        b.addEventListener('animationend', () => b.remove());
      }
      if (!idle) { blown += 1; setBlown(); }
      let caughtOnce = false;
      b.addEventListener('click', (e) => {
        if (caughtOnce) return;
        caughtOnce = true;
        caught += 1;
        setCaught();
        const r = layer.getBoundingClientRect();
        if (!reduce) sparkle(e.clientX - r.left, e.clientY - r.top, hue);
        b.style.transition = 'transform .3s ease, opacity .3s ease';
        b.style.transform = 'scale(.2)';
        b.style.opacity = '0';
        window.setTimeout(() => b.remove(), 300);
      });
      layer.appendChild(b);
    };

    const start = () => {
      if (playing) return;
      playing = true;
      setLabel('Stop');
      if (music) music.style.opacity = '1';
      if (wand && !reduce) wand.style.animation = 'mfWandPulse 1.4s ease-in-out infinite';
      if (hint) hint.style.opacity = '0';
      makeBubble(false);
      makeBubble(false);
      if (!reduce) timer = window.setInterval(() => makeBubble(false), 560);
    };
    const stop = () => {
      playing = false;
      setLabel(startLabel);
      if (music) music.style.opacity = '';
      if (wand) wand.style.animation = '';
      if (timer) { window.clearInterval(timer); timer = null; }
    };
    const clearAll = () => {
      stop();
      layer.querySelectorAll('.mfBubble, .mfSpark').forEach((x) => x.remove());
      blown = 0;
      caught = 0;
      setBlown();
      if (caughtEl) caughtEl.textContent = '0';
      if (hint) hint.style.opacity = '';
    };

    if (go) go.addEventListener('click', () => (playing ? stop() : start()));
    if (reset) reset.addEventListener('click', clearAll);

    // Ambient idle stream so the stage is never dead on arrival (skipped under reduced-motion).
    if (!reduce) {
      window.setInterval(() => {
        if (!playing && layer.querySelectorAll('.mfBubble').length < 4) makeBubble(true);
      }, 2600);
    }
  });
}

// mifoa buy box — radio-card / tier option select + qty stepper. Options and the
// stepper both drive one line-item quantity. Shopify's variant quantity rule is
// authoritative; when it has no maximum, the PDP has no artificial upper cap.
function initializeBuyBox(root = document) {
  root.querySelectorAll('[data-mf-multiples]:not([data-buybox-ready])').forEach((box) => {
    box.dataset.buyboxReady = 'true';
    const form = box.closest('form');
    const qtyInput = box.querySelector('[data-mf-quantity]');
    const qtyVal = box.querySelector('[data-mf-qtyval]');
    let prices = {};
    let model = {};
    try { prices = JSON.parse(box.getAttribute('data-mf-prices') || '{}'); } catch (_e) { prices = {}; }
    try { model = JSON.parse(box.getAttribute('data-mf-model') || '{}'); } catch (_e) { model = {}; }
    const opts = [...box.querySelectorAll('[data-buy-opt]')];
    const quantityRule = {
      min: Math.max(1, parseInt(model.min, 10) || 1),
      max: Number.isFinite(Number(model.max)) && Number(model.max) > 0 ? Number(model.max) : null,
      increment: Math.max(1, parseInt(model.increment, 10) || 1),
    };
    const clamp = (n) => {
      const numeric = Number.isFinite(Number(n)) ? Math.floor(Number(n)) : quantityRule.min;
      const offset = Math.max(0, numeric - quantityRule.min);
      let normalized = quantityRule.min + Math.round(offset / quantityRule.increment) * quantityRule.increment;
      if (quantityRule.max !== null) normalized = Math.min(normalized, quantityRule.max);
      return Math.max(quantityRule.min, normalized);
    };
    let qty = clamp(parseInt(model.dq, 10) || quantityRule.min);

    const addPriceEls = () => (form || box).querySelectorAll('[data-mf-add-price]');
    const formatMoney = (cents) => {
      const safeCents = Math.max(0, Math.round(Number(cents) || 0));
      const fractionDigits = safeCents % 100 === 0 ? 0 : 2;
      const locale = (model.currency || 'INR') === 'INR' && !/-IN$/i.test(model.locale || '') ? 'en-IN' : model.locale || 'en-IN';
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: model.currency || 'INR',
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: fractionDigits,
        }).format(safeCents / 100).replace(/\u00a0/g, ' ');
      } catch (_error) {
        return '₹' + (safeCents / 100).toLocaleString('en-IN', { maximumFractionDigits: fractionDigits });
      }
    };
    const totalFor = (n) => {
      const full = Math.max(0, Number(model.unitCents) || 0) * n;
      let discount = 0;
      if (model.fixed) {
        discount = (n >= 3 ? Number(model.off3Cents) || 0 : n >= 2 ? Number(model.off2Cents) || 0 : 0) * n;
      } else {
        const percentage = n >= 3 ? Number(model.p3) || 0 : n >= 2 ? Number(model.p2) || 0 : 0;
        discount = Math.floor(full * percentage / 100);
      }
      return Math.max(0, full - Math.max(0, Math.min(full, discount)));
    };

    const setQty = (n) => {
      qty = clamp(n);
      if (qtyInput) qtyInput.value = String(qty);
      if (qtyVal) qtyVal.textContent = String(qty);
      const p = prices[qty] || formatMoney(totalFor(qty));
      addPriceEls().forEach((el) => { el.textContent = p; });
      opts.forEach((o) => {
        const oq = parseInt(o.getAttribute('data-buy-opt'), 10) || 1;
        const on = oq === (qty >= 3 && opts.some((option) => Number(option.dataset.buyOpt) === 3) ? 3 : qty);
        o.classList.toggle('is-selected', on);
        if (o.hasAttribute('role')) o.setAttribute('aria-checked', String(on));
        if (o.hasAttribute('aria-pressed')) o.setAttribute('aria-pressed', String(on));
      });
      box.querySelectorAll('[data-mf-step]').forEach((button) => {
        const direction = parseInt(button.getAttribute('data-mf-step'), 10) || 0;
        const next = qty + direction * quantityRule.increment;
        button.disabled = next < quantityRule.min || (quantityRule.max !== null && next > quantityRule.max);
      });
    };

    opts.forEach((o) => {
      const oq = parseInt(o.getAttribute('data-buy-opt'), 10) || 1;
      o.addEventListener('click', () => setQty(oq));
      o.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        setQty(oq);
      });
    });
    box.querySelectorAll('[data-mf-step]').forEach((btn) => {
      btn.addEventListener('click', () => setQty(qty + (parseInt(btn.getAttribute('data-mf-step'), 10) || 0) * quantityRule.increment));
    });

    setQty(qty);
  });
}

function initializeSourceDesigns(root = document) {
  root.querySelectorAll('.mf-source-design [data-reveal]:not([data-source-reveal-ready])').forEach((element) => {
    element.dataset.sourceRevealReady = 'true';
    element.setAttribute('data-mf-reveal', '');
  });

  root.querySelectorAll('[data-faq]:not([data-source-ready])').forEach((item) => {
    item.dataset.sourceReady = 'true';
    const question = item.querySelector('[data-faq-q]');
    const answer = item.querySelector('[data-faq-a]');
    const chevron = item.querySelector('[data-faq-chev]');
    if (!question || !answer) return;

    question.addEventListener('click', () => {
      const open = item.classList.toggle('is-open');
      question.setAttribute('aria-expanded', String(open));
      if (chevron) chevron.style.transform = open ? 'rotate(180deg)' : '';
    });
  });

  root.querySelectorAll('[data-acc]:not([data-source-ready])').forEach((item) => {
    item.dataset.sourceReady = 'true';
    const trigger = item.firstElementChild || item;
    const body = item.querySelector('[data-acc-body]');
    const chevron = item.querySelector('[data-acc-chevron]');
    if (!trigger || !body) return;

    // Siblings sharing the same accordion group → one-open-at-a-time.
    const group = item.parentElement;
    const siblings = () => (group ? [...group.querySelectorAll(':scope > [data-acc]')] : [item]);

    const setOpen = (openItem, open) => {
      const openBody = openItem.querySelector('[data-acc-body]');
      const openChevron = openItem.querySelector('[data-acc-chevron]');
      const openTrigger = openItem.firstElementChild || openItem;
      openItem.classList.toggle('is-open', open);
      if (openBody) openBody.style.maxHeight = open ? `${openBody.scrollHeight}px` : '0px';
      if (openChevron) openChevron.style.transform = open ? 'rotate(180deg)' : '';
      openTrigger.setAttribute('aria-expanded', String(open));
    };

    // Normalise the design's pre-open first item (it ships with a guessed
    // inline max-height like 120px, which clips long answers). Treat any item
    // not explicitly closed (max-height:0) as the initially-open one and give
    // it its true height.
    const raw = (body.style.maxHeight || '').trim();
    const startsOpen = raw !== '' && raw !== '0px' && raw !== '0';

    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    setOpen(item, startsOpen);

    const toggle = () => {
      const open = !item.classList.contains('is-open');
      if (open) siblings().forEach((sib) => { if (sib !== item) setOpen(sib, false); });
      setOpen(item, open);
    };
    trigger.addEventListener('click', toggle);
    trigger.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      toggle();
    });
  });

  if (document.documentElement.dataset.mfGalleryDelegated !== 'true') {
    document.documentElement.dataset.mfGalleryDelegated = 'true';
    document.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      const layout = thumb.closest('.mf-source-layout') || document;
      const selected = thumb.dataset.galleryThumb;
      layout.querySelectorAll('[data-gallery-thumb]').forEach((candidate) => {
        candidate.style.borderColor = candidate === thumb ? '#3B49BE' : 'transparent';
      });
      layout.querySelectorAll('[data-gallery-main]').forEach((media) => {
        const active = media.dataset.galleryMain === selected;
        media.style.opacity = active ? '1' : '0';
        media.style.pointerEvents = active ? 'auto' : 'none';
      });
    });
  }

  root.querySelectorAll('[data-xfade]:not([data-source-ready])').forEach((reveal) => {
    reveal.dataset.sourceReady = 'true';
    const before = reveal.querySelector('[data-xfade-before]');
    const beforeInner = reveal.querySelector('[data-xfade-beforeinner]');
    const handle = reveal.querySelector('[data-xfade-handle]');
    if (!before || !handle) return;

    let dragging = false;
    const setReveal = (percentage) => {
      const value = Math.max(0, Math.min(100, percentage));
      before.style.width = `${value}%`;
      handle.style.left = `${value}%`;
      handle.setAttribute('aria-valuenow', String(Math.round(value)));
      if (beforeInner) beforeInner.style.width = `${reveal.getBoundingClientRect().width}px`;
    };
    const setFromPointer = (event) => {
      const rect = reveal.getBoundingClientRect();
      if (!rect.width) return;
      setReveal(((event.clientX - rect.left) / rect.width) * 100);
    };

    reveal.addEventListener('pointerdown', (event) => {
      dragging = true;
      reveal.setPointerCapture?.(event.pointerId);
      setFromPointer(event);
    });
    reveal.addEventListener('pointermove', (event) => {
      if (dragging) setFromPointer(event);
    });
    reveal.addEventListener('pointerup', (event) => {
      dragging = false;
      reveal.releasePointerCapture?.(event.pointerId);
    });
    reveal.addEventListener('pointercancel', () => { dragging = false; });
    handle.addEventListener('keydown', (event) => {
      const current = Number(handle.getAttribute('aria-valuenow')) || 50;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setReveal(current - 5);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        setReveal(current + 5);
      }
    });
    setReveal(Number(handle.getAttribute('aria-valuenow')) || 50);
  });

  root.querySelectorAll('[data-hero-chip]:not([data-source-ready])').forEach((chip) => {
    chip.dataset.sourceReady = 'true';
    chip.addEventListener('click', () => {
      const layout = chip.closest('.mf-source-layout') || document;
      const key = chip.dataset.heroChip;
      layout.querySelectorAll('[data-hero-chip]').forEach((candidate) => {
        const active = candidate === chip;
        candidate.style.background = active ? '#EDEFFC' : '#fff';
        candidate.style.borderColor = active ? '#3B49BE' : '#DCE1EC';
        candidate.style.color = active ? '#262F80' : '#363D52';
        candidate.setAttribute('aria-selected', String(active));
      });
      layout.querySelectorAll('[data-hero-stage]').forEach((stage) => {
        const active = stage.dataset.heroStage === key;
        stage.style.opacity = active ? '1' : '0';
        stage.style.pointerEvents = active ? 'auto' : 'none';
        stage.setAttribute('aria-hidden', String(!active));
      });

      const label = chip.dataset.heroLabel || chip.textContent.trim();
      const caption = chip.dataset.heroCaption || '';
      const price = chip.dataset.heroPrice || '';
      const code = layout.querySelector('[data-hero-caption-code]');
      const verb = layout.querySelector('[data-hero-caption-verb]');
      const priceNode = layout.querySelector('[data-hero-caption-price]');
      if (code) code.textContent = label;
      if (verb) verb.textContent = caption;
      if (priceNode) priceNode.textContent = price;
    });
  });

  root.querySelectorAll('[data-mf-scroll-buy]:not([data-source-ready])').forEach((button) => {
    button.dataset.sourceReady = 'true';
    button.addEventListener('click', () => {
      const purchaseArea = document.querySelector('.mf-source-product-hero .mf-product-multiples, .product-information, product-form, [data-product-form]');
      purchaseArea?.scrollIntoView({ behavior: prefersReducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
    });
  });

  root.querySelectorAll('[data-track]:not([data-source-ready])').forEach((form) => {
    form.dataset.sourceReady = 'true';
    const input = form.querySelector('[name="order"]');
    const error = form.querySelector('[data-terr]');
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      let orderNumber = (input?.value.trim() || '').toUpperCase().replace(/[^A-Z0-9-]/g, '');
      if (/^\d+$/.test(orderNumber)) orderNumber = 'MF-' + orderNumber;
      else if (/^MF\d+$/.test(orderNumber)) orderNumber = orderNumber.replace(/^MF/, 'MF-');
      if (!orderNumber) {
        input?.setAttribute('aria-invalid', 'true');
        if (error) error.style.display = 'block';
        input?.focus();
        return;
      }
      window.open(`https://mifoa.velocityshipping.in/track?order=${encodeURIComponent(orderNumber)}`, '_blank', 'noopener');
    });
    input?.addEventListener('input', () => {
      input.setAttribute('aria-invalid', 'false');
      if (error) error.style.display = 'none';
    });
  });

  root.querySelectorAll('[data-topen]:not([data-source-ready])').forEach((link) => {
    link.dataset.sourceReady = 'true';
    link.setAttribute('href', 'https://mifoa.velocityshipping.in/track');
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener');
  });

  root.querySelectorAll('[data-fsearch]:not([data-faqsearch-ready])').forEach((search) => {
    search.dataset.faqsearchReady = 'true';
    const layoutTypeOf = (el) => {
      if (!el) return 'any';
      if (el.closest('.mf-source-layout--mobile')) return 'mobile';
      if (el.closest('.mf-source-layout--desktop')) return 'desktop';
      return 'any';
    };
    const myType = layoutTypeOf(search);
    const inScope = (el) => {
      const t = layoutTypeOf(el);
      return myType === 'any' || t === 'any' || t === myType;
    };
    const count = [...document.querySelectorAll('[data-fcount]')].find(inScope) || null;
    const empty = [...document.querySelectorAll('[data-fempty]')].find(inScope) || null;
    const term = [...document.querySelectorAll('[data-fterm]')].find(inScope) || null;
    const categories = [...document.querySelectorAll('[data-cat]')].filter(inScope);
    const chips = [...document.querySelectorAll('[data-fchips] [data-jump]')].filter(inScope);
    let activeCategory = 'all';

    const filterFaqs = () => {
      const query = search.value.trim().toLowerCase();
      let shown = 0;
      categories.forEach((category) => {
        const categoryMatches = activeCategory === 'all' || category.dataset.cat === activeCategory;
        let categoryShown = 0;
        category.querySelectorAll('[data-faq]').forEach((item) => {
          const matches = categoryMatches && (!query || `${item.dataset.q || ''} ${item.textContent}`.toLowerCase().includes(query));
          item.style.display = matches ? '' : 'none';
          if (matches) categoryShown += 1;
        });
        category.style.display = categoryShown ? '' : 'none';
        shown += categoryShown;
      });
      if (count) count.textContent = query ? `${shown} ${shown === 1 ? 'ANSWER' : 'ANSWERS'} MATCH “${query.toUpperCase()}”` : '';
      if (empty) empty.style.display = query && shown === 0 ? 'block' : 'none';
      if (term) term.textContent = search.value.trim();
    };

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        activeCategory = chip.dataset.jump || 'all';
        chips.forEach((candidate) => candidate.classList.toggle('on', candidate === chip));
        filterFaqs();
      });
    });
    search.addEventListener('input', filterFaqs);
  });

  root.querySelectorAll('.mf-source-page--faq-legacy:not([data-source-ready])').forEach((faqPage) => {
    faqPage.dataset.sourceReady = 'true';
    const desktopLayout = faqPage.querySelector('.mf-source-layout--desktop');
    const search = desktopLayout?.querySelector('[data-fsearch]');
    const count = desktopLayout?.querySelector('[data-fcount]');
    const empty = desktopLayout?.querySelector('[data-fempty]');
    const term = desktopLayout?.querySelector('[data-fterm]');
    const categories = [...(desktopLayout?.querySelectorAll('[data-cat]') || [])];
    const chips = [...(desktopLayout?.querySelectorAll('[data-fchips] [data-jump]') || [])];
    let activeCategory = 'all';

    const filterFaqs = () => {
      const query = search?.value.trim().toLowerCase() || '';
      let shown = 0;
      categories.forEach((category) => {
        const categoryMatches = activeCategory === 'all' || category.dataset.cat === activeCategory;
        let categoryShown = 0;
        category.querySelectorAll('[data-faq]').forEach((item) => {
          const matches = categoryMatches && (!query || `${item.dataset.q || ''} ${item.textContent}`.toLowerCase().includes(query));
          item.style.display = matches ? '' : 'none';
          if (matches) categoryShown += 1;
        });
        category.style.display = categoryShown ? '' : 'none';
        shown += categoryShown;
      });
      if (count) count.textContent = query ? `${shown} ${shown === 1 ? 'ANSWER' : 'ANSWERS'} MATCH “${query.toUpperCase()}”` : '';
      if (empty) empty.style.display = query && shown === 0 ? 'block' : 'none';
      if (term) term.textContent = search?.value.trim() || '';
    };

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        activeCategory = chip.dataset.jump || 'all';
        chips.forEach((candidate) => candidate.classList.toggle('on', candidate === chip));
        filterFaqs();
      });
    });
    search?.addEventListener('input', filterFaqs);
  });

  root.querySelectorAll('.mf-source-page--home button:not([data-source-ready])').forEach((button) => {
    if (!button.hasAttribute('data-add') && !button.textContent.toLowerCase().includes('shop the collection')) return;
    button.dataset.sourceReady = 'true';
    button.addEventListener('click', () => { window.location.href = '/collections/all'; });
  });

  root.querySelectorAll('[data-wixo-ignite]:not([data-source-ready])').forEach((button) => {
    button.dataset.sourceReady = 'true';
    let lit = false;
    const layout = button.closest('.mf-source-layout') || document;
    const update = () => {
      const flame = layout.querySelector('[data-wixo-flame]');
      const glow = layout.querySelector('[data-wixo-glow]');
      const slide = layout.querySelector('[data-wixo-slide]');
      const state = layout.querySelector('[data-wixo-state]');
      const label = layout.querySelector('[data-wixo-ignite-label]');
      if (flame) { flame.style.opacity = lit ? '1' : '0'; flame.style.transform = `translateX(-50%) scaleY(${lit ? '.82' : '.18'})`; }
      if (glow) glow.style.opacity = lit ? '1' : '0';
      if (slide) slide.style.bottom = lit ? '38px' : '4px';
      if (state) state.textContent = lit ? 'ON' : 'OFF';
      if (label) label.textContent = lit ? 'Slide down to stop' : 'Slide up to light';
    };
    button.addEventListener('click', () => { lit = !lit; update(); });
  });

  root.querySelectorAll('[data-wixo-int]:not([data-source-ready])').forEach((button) => {
    button.dataset.sourceReady = 'true';
    button.addEventListener('click', () => {
      const layout = button.closest('.mf-source-layout') || document;
      const scale = { low: .58, med: .82, high: 1 }[button.dataset.wixoInt] || .82;
      const flame = layout.querySelector('[data-wixo-flame]');
      if (flame) flame.style.transform = `translateX(-50%) scaleY(${scale})`;
      layout.querySelectorAll('[data-wixo-int]').forEach((candidate) => {
        const active = candidate === button;
        candidate.style.background = active ? 'rgba(255,255,255,.14)' : 'transparent';
        candidate.style.color = active ? '#fff' : '#D6C7B4';
      });
    });
  });

  root.querySelectorAll('[data-collection-sort]:not([data-source-ready])').forEach((select) => {
    select.dataset.sourceReady = 'true';
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

  root.querySelectorAll('.mf-source-collection:not([data-source-ready])').forEach((collection) => {
    collection.dataset.sourceReady = 'true';
    const typeFilters = [...collection.querySelectorAll('[data-collection-type]')];
    const stockFilters = [...collection.querySelectorAll('[data-collection-stock]')];
    const cards = [...collection.querySelectorAll('[data-collection-card]')];
    let activeType = 'all';
    let activeStock = 'all';

    const applyCollectionFilters = () => {
      cards.forEach((card) => {
        const matchesType = activeType === 'all' || card.dataset.productType === activeType;
        const matchesStock = activeStock === 'all' || card.dataset.stock === activeStock;
        card.hidden = !(matchesType && matchesStock);
      });
    };

    typeFilters.forEach((filter) => filter.addEventListener('click', () => {
      activeType = filter.dataset.collectionType;
      typeFilters.forEach((candidate) => candidate.classList.toggle('is-active', candidate === filter));
      applyCollectionFilters();
    }));

    stockFilters.forEach((filter) => filter.addEventListener('click', () => {
      activeStock = filter.dataset.collectionStock;
      stockFilters.forEach((candidate) => candidate.classList.toggle('is-active', candidate === filter));
      applyCollectionFilters();
    }));
  });

  root.querySelectorAll('.mf-source-journal:not([data-source-ready])').forEach((journal) => {
    journal.dataset.sourceReady = 'true';
    const search = journal.querySelector('[data-journal-search]');
    const filters = [...journal.querySelectorAll('[data-journal-filter]')];
    const cards = [...journal.querySelectorAll('[data-journal-card]')];
    let activeTag = 'all';

    const applyJournalFilter = () => {
      const query = search?.value.trim().toLowerCase() || '';
      cards.forEach((card) => {
        const matchesTag = activeTag === 'all' || card.dataset.journalTags.includes(activeTag);
        const matchesQuery = !query || card.dataset.journalText.toLowerCase().includes(query);
        card.hidden = !(matchesTag && matchesQuery);
      });
    };

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeTag = filter.dataset.journalFilter;
        filters.forEach((candidate) => candidate.classList.toggle('is-active', candidate === filter));
        applyJournalFilter();
      });
    });
    search?.addEventListener('input', applyJournalFilter);
  });

  root.querySelectorAll('[data-article-content]:not([data-source-ready])').forEach((content) => {
    content.dataset.sourceReady = 'true';
    const article = content.closest('.mf-source-article');
    const toc = article?.querySelector('[data-article-toc]');
    if (!toc) return;

    content.querySelectorAll('h2').forEach((heading, index) => {
      if (!heading.id) heading.id = `article-section-${index + 1}`;
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      toc.append(link);
    });
  });

  root.querySelectorAll('[data-copy-url]:not([data-source-ready])').forEach((button) => {
    button.dataset.sourceReady = 'true';
    button.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(window.location.href);
        button.textContent = 'Copied';
      } catch (_error) {
        button.textContent = 'Copy unavailable';
      }
    });
  });
}

// mifoa AJAX add-to-cart: intercept plain product forms (buy box, product cards)
// so adds go through /cart/add.js and open the Horizon cart drawer instead of
// navigating to /cart. Dispatches the theme's `cart:update` event so the drawer
// cart bubble and cart items all refresh themselves. Magic-safe:
// checkout button/forms untouched.
function initializeMifoaCartAjax() {
  if (window.__mfCartAjaxReady) return;
  window.__mfCartAjaxReady = true;

  let cartFeedbackTimeout;

  const clearCartSkeleton = () => {
    if (cartFeedbackTimeout) window.clearTimeout(cartFeedbackTimeout);
    cartFeedbackTimeout = undefined;
    document.querySelectorAll('[data-mf-cart-skeleton]').forEach((skeleton) => skeleton.remove());
    document.querySelectorAll('cart-items-component[data-mf-cart-busy="true"]').forEach((cartItems) => {
      cartItems.removeAttribute('data-mf-cart-busy');
      cartItems.removeAttribute('aria-busy');
    });
    document.querySelectorAll('.cart-drawer__dialog.mf-cart-awaiting').forEach((dialog) => {
      dialog.classList.remove('mf-cart-awaiting');
    });
  };

  const showCartSkeleton = () => {
    clearCartSkeleton();
    const drawer = document.querySelector('cart-drawer-component');
    const dialog = drawer?.querySelector('.cart-drawer__dialog');
    const cartItems = dialog?.querySelector('cart-items-component');
    if (!drawer || !dialog || !cartItems) return drawer;

    const skeleton = document.createElement('div');
    skeleton.className = 'mf-cart-item-skeleton';
    skeleton.dataset.mfCartSkeleton = 'true';
    skeleton.setAttribute('aria-hidden', 'true');
    skeleton.innerHTML = `
      <span class="mf-cart-item-skeleton__media mf-cart-skeleton-shape"></span>
      <span class="mf-cart-item-skeleton__body">
        <span class="mf-cart-item-skeleton__line mf-cart-item-skeleton__line--title mf-cart-skeleton-shape"></span>
        <span class="mf-cart-item-skeleton__line mf-cart-item-skeleton__line--price mf-cart-skeleton-shape"></span>
        <span class="mf-cart-item-skeleton__controls mf-cart-skeleton-shape"></span>
      </span>`;

    const header = cartItems.querySelector('.cart-drawer__header');
    if (header) header.insertAdjacentElement('afterend', skeleton);
    else cartItems.prepend(skeleton);
    cartItems.dataset.mfCartBusy = 'true';
    cartItems.setAttribute('aria-busy', 'true');
    dialog.classList.add('mf-cart-awaiting');
    if (!dialog.hasAttribute('open') && typeof drawer.open === 'function') drawer.open();

    // Never leave a stale pending state after a network or extension failure.
    cartFeedbackTimeout = window.setTimeout(clearCartSkeleton, 15000);
    return drawer;
  };

  document.addEventListener('cart:update', clearCartSkeleton);
  document.addEventListener('cart:error', clearCartSkeleton);

  const dispatchCartUpdate = (
    resource,
    sourceId,
    variantId,
    itemCount,
    sections,
    openDrawer,
    source = 'product-form-component',
  ) => {
    const ev = new Event('cart:update', { bubbles: true });
    ev.detail = {
      resource,
      sourceId: sourceId || 'mifoa-ajax',
      data: {
        source,
        itemCount,
        variantId,
        sections,
      },
    };
    const suppressAutoOpen = openDrawer?.hasAttribute('auto-open');
    if (suppressAutoOpen) openDrawer.removeAttribute('auto-open');
    try {
      document.dispatchEvent(ev);
    } finally {
      if (suppressAutoOpen) openDrawer.setAttribute('auto-open', '');
    }
  };

  const getCartSectionIds = () => [...document.querySelectorAll('cart-items-component[data-section-id]')]
    .map((item) => item.dataset.sectionId)
    .filter((id, index, ids) => id && ids.indexOf(id) === index);

  const getAppliedDiscountCodes = (extraCode = '') => [...new Set([
    ...[...document.querySelectorAll('.cart-discount__pill[data-discount-code]')]
      .map((pill) => pill.dataset.discountCode)
      .filter(Boolean),
    String(extraCode || '').trim(),
  ].filter(Boolean))];


  const normalizeDiscountCode = (value) => String(value || '').trim().toUpperCase();
  const dedupeDiscountCodes = (codes = []) => {
    const unique = new Map();
    codes.forEach((value) => {
      const code = String(value || '').trim();
      const key = normalizeDiscountCode(code);
      if (key && !unique.has(key)) unique.set(key, code);
    });
    return [...unique.values()];
  };

  const getCartDiscountCodes = (cart = null) => {
    const codes = [];
    const hasServerShape = Boolean(
      cart
      && (
        Array.isArray(cart.discount_codes)
        || Array.isArray(cart.cart_level_discount_applications)
        || Array.isArray(cart.items)
      )
    );

    if (!hasServerShape) return dedupeDiscountCodes(getAppliedDiscountCodes());

    (Array.isArray(cart.discount_codes) ? cart.discount_codes : []).forEach((discount) => {
      if (discount?.code) codes.push(discount.code);
    });
    (Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : []
    ).forEach((application) => {
      if (application?.type === 'discount_code' && application.title) {
        codes.push(application.title);
      }
    });
    (Array.isArray(cart.items) ? cart.items : []).forEach((item) => {
      (Array.isArray(item.line_level_discount_allocations)
        ? item.line_level_discount_allocations
        : []
      ).forEach((allocation) => {
        const application = allocation?.discount_application;
        if (application?.type === 'discount_code' && application.title) {
          codes.push(application.title);
        }
      });
    });

    return dedupeDiscountCodes(codes);
  };

  const warmMagicAfterCart = () => {
    window.setTimeout(() => {
      if (typeof window.__mfLoadRazorpay === 'function') {
        void window.__mfLoadRazorpay().catch(() => {});
      }
    }, 350);
  };

  const addWithRenderedCart = async (formData, sourceId, discountCode = '') => {
    const sectionIds = getCartSectionIds();

    if (sectionIds.length) {
      formData.set('sections', sectionIds.join(','));
      formData.set('sections_url', window.location.pathname);
    }

    const responsePromise = fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' },
    });

    const drawer = showCartSkeleton();

    try {
      const response = await responsePromise;
      const resource = await response.json();
      if (!response.ok || resource.status) {
        const cartError = new Error(resource.description || resource.message || 'We could not update your cart.');
        cartError.mfCartRejected = true;
        throw cartError;
      }

      const quantity = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);
      const variantId = formData.get('id');
      let cartResource = resource;

      // Render the successful add response immediately so the drawer never
      // waits on a subsequent discount request before showing the new line.
      dispatchCartUpdate(resource, sourceId, variantId, quantity, resource.sections || {}, drawer);
      clearCartSkeleton();
      warmMagicAfterCart();

      if (discountCode) {
        try {
          const discountPayload = { discount: getAppliedDiscountCodes(discountCode).join(',') };
          if (sectionIds.length) {
            discountPayload.sections = sectionIds.join(',');
            discountPayload.sections_url = window.location.pathname;
          }
          const discountResponse = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(discountPayload),
          });
          const discountedCart = await discountResponse.json();
          if (!discountResponse.ok || discountedCart.errors) {
            throw new Error(discountedCart.description || discountedCart.message || 'discount failed');
          }
          cartResource = discountedCart;

          // The discount endpoint can return section HTML generated before the
          // discount cookie/cart state has settled. Ask every cart component to
          // re-render its own section from Shopify instead of trusting that
          // potentially stale payload. This second event is a synchronization
          // event (not another add), so the cart bubble is set to the absolute
          // item count rather than incremented twice.
          const finalItemCount = Number.isFinite(Number(discountedCart.item_count))
            ? Number(discountedCart.item_count)
            : quantity;
          dispatchCartUpdate(
            discountedCart,
            `${sourceId || 'mifoa-ajax'}-discount-sync`,
            variantId,
            finalItemCount,
            undefined,
            drawer,
            'mifoa-discount-sync',
          );
        } catch (discountError) {
          // The product has already been added at this point. Never fall back to
          // a second native form submission, which would duplicate the line.
          // Render the successful add response and keep checkout available.
          console.error('Mifoa volume discount could not be applied:', discountError);
        }
      }

      return cartResource;
    } catch (error) {
      clearCartSkeleton();
      throw error;
    }
  };

  // Shopify is currently at its 25-active-automatic-discount limit. FLIQ's
  // product-specific FLIQ2 code therefore cannot yet be another automatic
  // rule. Add the variant and apply the code in one documented Cart AJAX
  // update request so its drawer experience matches automatic-discount PDPs:
  // one request, one section render, and no undiscounted intermediate state.
  const updateWithDiscountedCart = async (formData, sourceId, discountCode, offerGuard = null) => {
    const sectionIds = getCartSectionIds();
    const quantity = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);
    const variantId = String(formData.get('id') || '').trim();
    if (!variantId) {
      const variantError = new Error('Cannot find variant');
      variantError.mfCartRejected = true;
      throw variantError;
    }

    const existingLinesByKey = new Map();
    document.querySelectorAll(
      `cart-quantity-selector-component[data-variant-id="${variantId}"]`,
    ).forEach((selector) => {
      const input = selector.querySelector('input[ref="quantityInput"]');
      const quantityValue = parseInt(input?.value, 10) || 0;
      const rowKey = selector.closest('[data-key]')?.dataset.key;
      const dedupeKey = rowKey || `variant:${variantId}`;
      if (!existingLinesByKey.has(dedupeKey)) {
        existingLinesByKey.set(dedupeKey, {
          key: rowKey || variantId,
          quantity: quantityValue,
        });
      }
    });
    const existingLines = [...existingLinesByKey.values()];
    const hasLineProperties = [...formData.keys()].some((key) => key.startsWith('properties['));
    const hasSellingPlan = Boolean(String(formData.get('selling_plan') || '').trim());

    // update.js uses absolute quantities and Shopify recommends a line key
    // when the same variant is split into multiple cart lines. Preserve the
    // proven add-then-code path for those uncommon, ambiguous cart shapes.
    if (existingLines.length > 1 || hasLineProperties || hasSellingPlan) {
      return addWithRenderedCart(formData, sourceId, discountCode);
    }
    const existingLine = existingLines[0];
    const updateKey = existingLine?.key || variantId;
    const existingQuantity = existingLine?.quantity || 0;

    if (offerGuard) {
      const guardedVariantId = String(offerGuard.variantId || '').trim();
      const maxCartQuantity = Math.max(1, Number(offerGuard.maxCartQuantity) || 1);
      if (!guardedVariantId || guardedVariantId !== variantId) {
        const offerVariantError = new Error('This cart offer is temporarily unavailable.');
        offerVariantError.mfCartRejected = true;
        throw offerVariantError;
      }
      if (existingQuantity >= maxCartQuantity) {
        const offerQuantityError = new Error('WIXO is already in your cart.');
        offerQuantityError.mfCartRejected = true;
        throw offerQuantityError;
      }
    }

    const payload = {
      updates: { [updateKey]: existingQuantity + quantity },
      discount: getAppliedDiscountCodes(discountCode).join(','),
    };
    if (sectionIds.length) {
      payload.sections = sectionIds.join(',');
      payload.sections_url = window.location.pathname;
    }

    const responsePromise = fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const drawer = showCartSkeleton();

    try {
      const response = await responsePromise;
      const resource = await response.json();
      if (!response.ok || resource.status || resource.errors) {
        const cartError = new Error(
          resource.description || resource.message || resource.errors || 'We could not update your cart.',
        );
        cartError.mfCartRejected = true;
        throw cartError;
      }

      const itemCount = Number.isFinite(Number(resource.item_count))
        ? Number(resource.item_count)
        : Array.isArray(resource.items)
          ? resource.items.reduce((total, item) => total + (Number(item.quantity) || 0), 0)
          : null;
      if (!Number.isFinite(itemCount)) {
        throw new Error('Shopify returned an incomplete cart response.');
      }

      if (offerGuard) {
        const expectedDiscount = Math.max(0, Number(offerGuard.expectedDiscount) || 0);
        const guardedVariantId = String(offerGuard.variantId || variantId);
        const offerLine = Array.isArray(resource.items)
          ? resource.items.find((item) => String(item.variant_id) === guardedVariantId)
          : null;
        const originalLinePrice = Number(
          offerLine?.original_line_price
          ?? ((Number(offerLine?.original_price) || Number(offerLine?.price) || 0) * (Number(offerLine?.quantity) || 0)),
        );
        const finalLinePrice = Number(offerLine?.final_line_price ?? offerLine?.line_price ?? originalLinePrice);
        const appliedSaving = originalLinePrice - finalLinePrice;
        const appliedCode = Array.isArray(resource.discount_codes)
          ? resource.discount_codes.find(
              (entry) => String(entry?.code || '').toLowerCase() === String(discountCode).toLowerCase(),
            )
          : null;
        const offerApplied = Boolean(
          offerLine
          && appliedCode?.applicable === true
          && expectedDiscount > 0
          && appliedSaving >= expectedDiscount,
        );

        if (!offerApplied) {
          const rollbackPayload = {
            updates: { [updateKey]: existingQuantity },
            discount: getAppliedDiscountCodes()
              .filter((code) => String(code).toLowerCase() !== String(discountCode).toLowerCase())
              .join(','),
          };
          if (sectionIds.length) {
            rollbackPayload.sections = sectionIds.join(',');
            rollbackPayload.sections_url = window.location.pathname;
          }

          try {
            const rollbackResponse = await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(rollbackPayload),
            });
            const rollbackCart = await rollbackResponse.json();
            if (!rollbackResponse.ok || rollbackCart.status || rollbackCart.errors) {
              throw new Error('Shopify could not roll back the unpriced add-on.');
            }
            const rollbackItemCount = Number.isFinite(Number(rollbackCart.item_count))
              ? Number(rollbackCart.item_count)
              : Array.isArray(rollbackCart.items)
                ? rollbackCart.items.reduce((total, item) => total + (Number(item.quantity) || 0), 0)
                : 0;
            dispatchCartUpdate(
              rollbackCart,
              `${sourceId || 'mifoa-ajax'}-offer-rollback`,
              variantId,
              rollbackItemCount,
              rollbackCart.sections || {},
              drawer,
              'mifoa-offer-rollback',
            );
          } catch (rollbackError) {
            console.error('Mifoa cart offer rollback failed:', rollbackError);
            dispatchCartUpdate(
              resource,
              `${sourceId || 'mifoa-ajax'}-offer-review`,
              variantId,
              itemCount,
              resource.sections || {},
              drawer,
              'mifoa-offer-review',
            );
          }

          const offerError = new Error(
            'The ₹999 WIXO offer could not be applied. Please review your cart and try again.',
          );
          offerError.mfCartRejected = true;
          throw offerError;
        }
      }

      dispatchCartUpdate(
        resource,
        sourceId,
        variantId,
        itemCount,
        resource.sections || {},
        drawer,
        'mifoa-discounted-add',
      );
      clearCartSkeleton();
      warmMagicAfterCart();
      return resource;
    } catch (error) {
      clearCartSkeleton();
      throw error;
    }
  };

  window.__mfAjaxAddVariant = async (variantId, quantity = 1, sourceId = 'mifoa-collection') => {
    const formData = new FormData();
    formData.set('id', String(variantId));
    formData.set('quantity', String(quantity));
    return addWithRenderedCart(formData, sourceId);
  };

  window.__mfAjaxAdd = async (form, triggerBtn) => {
    const fd = new FormData(form);
    const status = form.querySelector('.mf-object-form-status');
    if (status) status.textContent = '';
    // Source of truth for quantity is the buy box display (third-party scripts
    // have been observed rewriting the hidden input) — re-assert at submit time.
    const mfBox = form.querySelector('[data-mf-multiples]');
    const mfQty = (mfBox && mfBox.querySelector('[data-mf-qtyval]'))
      || form.querySelector('[data-mf-object-quantity-value]')
      || form.querySelector('[data-parke-quantity-value]')
      || form.querySelector('[data-woolyv2-quantity-value]');
    if (mfQty) {
      const q = parseInt((mfQty.value || mfQty.textContent || '').trim(), 10);
      if (q > 0) fd.set('quantity', String(q));
    }
    const buttons = [
      ...form.querySelectorAll('button[type="submit"]'),
      ...(form.id ? document.querySelectorAll(`button[form="${form.id}"]`) : []),
    ];
    const saved = buttons.map((b) => ({ b, html: b.innerHTML }));
    buttons.forEach((b) => { b.disabled = true; });
    try {
      const discountCode = (form.dataset.mfVolumeCode || '').trim();
      const offerGuard = form.dataset.mfOfferVariantId
        ? {
            variantId: form.dataset.mfOfferVariantId,
            expectedDiscount: form.dataset.mfOfferExpectedDiscount,
            maxCartQuantity: form.dataset.mfOfferMaxCartQuantity,
          }
        : null;
      if (form.dataset.mfPanditWixoOffer === 'true') {
        if (typeof window.__mfAddPanditWixoOffer !== 'function') {
          const offerUnavailable = new Error('This cart offer is temporarily unavailable.');
          offerUnavailable.mfCartRejected = true;
          throw offerUnavailable;
        }
        await window.__mfAddPanditWixoOffer(fd, form.id);
      } else if (discountCode) {
        await updateWithDiscountedCart(fd, form.id, discountCode, offerGuard);
      } else {
        await addWithRenderedCart(fd, form.id);
      }
      buttons.forEach((b) => {
        const span = b.querySelector('span');
        if (span) { span.dataset.mfPrev = span.textContent; span.textContent = 'Added \u2713'; }
        else { b.dataset.mfPrev = b.textContent; b.textContent = 'Added \u2713'; }
      });
      window.setTimeout(() => {
        saved.forEach(({ b, html }) => { b.innerHTML = html; b.disabled = false; });
      }, 1400);
    } catch (e) {
      saved.forEach(({ b, html }) => { b.innerHTML = html; b.disabled = false; });
      // A failed or uncertain request must never be followed by an automatic
      // native resubmission: the first request may already have reached
      // Shopify, and a second submit can duplicate the line. Keep the shopper
      // on the PDP, restore the CTA, and let them retry deliberately.
      if (status) {
        status.textContent = e?.mfCartRejected
          ? e.message
          : 'We could not update your cart. Please try again.';
      }
    }
  };

  // Checkout-safe Pandit Ji + WIXO offer.
  // The offer is a real, ACTIVE, checkout-eligible ₹999 merchandise line.
  // MIFOA500 remains the only customer coupon; the retired WIXO code is
  // stripped before Magic Checkout so Razorpay never has to combine coupons.
  const mfPanditWixoOffer = {
    retiredCode: 'MFPJWX9K7R4D2',
    panditProductId: 10299729019193,
    regularWixoVariantId: 53488168665401,
    offerWixoVariantId: 54375702921529,
    offerUnitPrice: 99900,
  };
  const mfPanditWixoState = {
    running: null,
    dirty: false,
    latest: null,
    forceRender: false,
    lastError: null,
  };

  const isPanditItem = (item) => (
    Number(item?.product_id) === mfPanditWixoOffer.panditProductId
  );
  const isRegularWixoItem = (item) => (
    Number(item?.variant_id) === mfPanditWixoOffer.regularWixoVariantId
  );
  const isOfferWixoItem = (item) => (
    Number(item?.variant_id) === mfPanditWixoOffer.offerWixoVariantId
  );
  const cartItemQuantity = (items, predicate) => items.reduce(
    (total, item) => total + (predicate(item) ? Number(item.quantity) || 0 : 0),
    0,
  );
  const retiredCodeMatches = (value) => (
    normalizeDiscountCode(value) === mfPanditWixoOffer.retiredCode
  );

  const fetchPanditWixoCart = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart.js', {
      headers: { Accept: 'application/json' },
    });
    const cart = await response.json();
    if (!response.ok || cart.status || cart.errors || !Array.isArray(cart.items)) {
      const error = new Error(
        cart.description || cart.message || 'We could not verify your cart.',
      );
      error.mfCartRejected = true;
      throw error;
    }
    return cart;
  };

  const updatePanditWixoCart = async (payload) => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const cart = await response.json();
    if (!response.ok || cart.status || cart.errors || !Array.isArray(cart.items)) {
      const error = new Error(
        cart.description || cart.message || cart.errors || 'We could not update your cart.',
      );
      error.mfCartRejected = true;
      throw error;
    }
    return cart;
  };

  const panditWixoQuantities = (cart = {}) => {
    const items = Array.isArray(cart.items) ? cart.items : [];
    return {
      pandit: cartItemQuantity(items, isPanditItem),
      regular: cartItemQuantity(items, isRegularWixoItem),
      offer: cartItemQuantity(items, isOfferWixoItem),
    };
  };

  const validatePanditWixoCart = (cart = {}) => {
    const items = Array.isArray(cart.items) ? cart.items : [];
    const quantities = panditWixoQuantities(cart);
    const retiredCodePresent = getCartDiscountCodes(cart).some(retiredCodeMatches);
    const offerLines = items.filter(isOfferWixoItem);
    const offerPriceSafe = offerLines.every((item) => (
      Number(item.original_price ?? item.price) === mfPanditWixoOffer.offerUnitPrice
    ));
    const correctMerchandise = quantities.pandit > 0
      ? quantities.regular === 0
      : quantities.offer === 0;

    return {
      ok: !retiredCodePresent && offerPriceSafe && correctMerchandise,
      retiredCodePresent,
      offerPriceSafe,
      correctMerchandise,
      quantities,
    };
  };

  const syncPanditWixoOfferUI = (cart = {}) => {
    if (!Array.isArray(cart.items)) return false;

    const quantities = panditWixoQuantities(cart);
    const shouldShow = quantities.pandit > 0 && (quantities.regular + quantities.offer) === 0;
    const addons = [...document.querySelectorAll('[data-mf-cart-addon]')];

    addons.forEach((addon) => {
      if (!(addon instanceof HTMLElement)) return;
      addon.hidden = !shouldShow;
      addon.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    });

    return shouldShow && addons.length > 0;
  };

  const showPanditWixoStatus = (message = '') => {
    let status = document.querySelector('[data-mf-cart-offer-status]');
    const checkout = document.querySelector('[name="checkout"]');

    if (!status && checkout instanceof HTMLElement) {
      status = document.createElement('p');
      status.dataset.mfCartOfferStatus = 'true';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.style.cssText = 'margin:0 0 12px;color:#9f2d2d;font-size:14px;line-height:1.4;';
      checkout.parentElement?.insertBefore(status, checkout);
    }

    if (status instanceof HTMLElement) {
      status.textContent = message;
      status.hidden = !message;
    }
  };
  window.__mfShowPanditWixoStatus = showPanditWixoStatus;

  const dispatchFreshPanditWixoCart = (cart) => {
    const itemCount = Number.isFinite(Number(cart?.item_count))
      ? Number(cart.item_count)
      : Array.isArray(cart?.items)
        ? cart.items.reduce((total, item) => total + (Number(item.quantity) || 0), 0)
        : 0;

    dispatchCartUpdate(
      cart,
      'mifoa-wixo-offer-reconcile',
      '',
      itemCount,
      undefined,
      document.querySelector('cart-drawer-component'),
      'mifoa-wixo-offer-reconcile',
    );
  };

  const runPanditWixoPass = async (cart) => {
    const items = Array.isArray(cart.items) ? cart.items : [];
    const quantities = panditWixoQuantities(cart);
    const regularLines = items.filter(isRegularWixoItem);
    const offerLines = items.filter(isOfferWixoItem);
    const targetIsOffer = quantities.pandit > 0;
    const sourceLines = targetIsOffer ? regularLines : offerLines;
    const targetLines = targetIsOffer ? offerLines : regularLines;
    const targetVariantId = targetIsOffer
      ? mfPanditWixoOffer.offerWixoVariantId
      : mfPanditWixoOffer.regularWixoVariantId;
    const totalWixoQuantity = quantities.regular + quantities.offer;
    const currentCodes = getCartDiscountCodes(cart);
    const desiredCodes = currentCodes.filter((code) => !retiredCodeMatches(code));
    const retiredCodePresent = currentCodes.some(retiredCodeMatches);
    const needsMerchandiseSwap = sourceLines.length > 0;
    const needsLineCollapse = targetLines.length > 1;
    const payload = {};

    if (needsMerchandiseSwap || needsLineCollapse) {
      const updates = {};
      sourceLines.forEach((item) => {
        if (!item.key) {
          const error = new Error('We need to refresh an older WIXO cart item before checkout.');
          error.mfCartRejected = true;
          throw error;
        }
        updates[item.key] = 0;
      });

      if (targetLines.length) {
        const keeper = targetLines[0];
        if (!keeper.key) {
          const error = new Error('We need to refresh your WIXO cart item before checkout.');
          error.mfCartRejected = true;
          throw error;
        }
        updates[keeper.key] = totalWixoQuantity;
        targetLines.slice(1).forEach((item) => {
          if (item.key) updates[item.key] = 0;
        });
      } else if (totalWixoQuantity > 0) {
        updates[targetVariantId] = totalWixoQuantity;
      }

      payload.updates = updates;
    }

    if (retiredCodePresent) {
      payload.discount = dedupeDiscountCodes(desiredCodes).join(',');
    }

    const mutated = Object.keys(payload).length > 0;
    let settled = mutated ? await updatePanditWixoCart(payload) : cart;
    let check = validatePanditWixoCart(settled);

    if (!check.ok) {
      settled = await fetchPanditWixoCart();
      check = validatePanditWixoCart(settled);
    }

    if (!check.ok) {
      const error = new Error(
        check.offerPriceSafe
          ? 'We could not prepare the WIXO offer for checkout. Please try again.'
          : 'The WIXO offer price could not be verified. Please try again.',
      );
      error.mfCartRejected = true;
      throw error;
    }

    return { cart: settled, mutated };
  };

  const drainPanditWixoQueue = async () => {
    let settled = null;

    while (mfPanditWixoState.dirty) {
      mfPanditWixoState.dirty = false;
      const forceRender = mfPanditWixoState.forceRender;
      mfPanditWixoState.forceRender = false;
      let cart = mfPanditWixoState.latest;
      mfPanditWixoState.latest = null;

      if (!cart || !Array.isArray(cart.items)) cart = await fetchPanditWixoCart();

      const result = await runPanditWixoPass(cart);
      settled = result.cart;
      mfPanditWixoState.lastError = null;
      showPanditWixoStatus('');
      syncPanditWixoOfferUI(settled);
      if (forceRender || result.mutated) dispatchFreshPanditWixoCart(settled);
    }

    return settled || fetchPanditWixoCart();
  };

  const schedulePanditWixoReconcile = (snapshot = null, forceRender = false) => {
    mfPanditWixoState.latest = snapshot && Array.isArray(snapshot.items) ? snapshot : null;
    mfPanditWixoState.forceRender = mfPanditWixoState.forceRender || forceRender;
    mfPanditWixoState.dirty = true;

    if (!mfPanditWixoState.running) {
      mfPanditWixoState.running = drainPanditWixoQueue()
        .catch((error) => {
          mfPanditWixoState.lastError = error;
          showPanditWixoStatus(error.message || 'Please retry the cart update.');
          throw error;
        })
        .finally(() => {
          mfPanditWixoState.running = null;
          if (mfPanditWixoState.dirty) {
            void schedulePanditWixoReconcile().catch(() => {});
          }
        });
    }

    return mfPanditWixoState.running;
  };

  window.__mfEnsurePanditWixoOfferReady = async () => {
    let cart;
    do {
      cart = await schedulePanditWixoReconcile(null, false);
    } while (mfPanditWixoState.running || mfPanditWixoState.dirty);

    const validation = validatePanditWixoCart(cart);
    if (!validation.ok) {
      throw mfPanditWixoState.lastError
        || new Error('Please retry the cart update before checkout.');
    }
    showPanditWixoStatus('');
    return cart;
  };

  window.__mfAddPanditWixoOffer = async (formData, sourceId) => {
    const sectionIds = getCartSectionIds();
    const quantity = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);
    const variantId = String(formData.get('id') || '').trim();
    const drawer = showCartSkeleton();

    try {
      if (variantId !== String(mfPanditWixoOffer.offerWixoVariantId)) {
        const error = new Error('This cart offer is temporarily unavailable.');
        error.mfCartRejected = true;
        throw error;
      }

      const before = await window.__mfEnsurePanditWixoOfferReady();
      const beforeQuantities = panditWixoQuantities(before);
      if (beforeQuantities.pandit < 1) {
        const error = new Error('Keep Pandit Ji in your cart to add WIXO for ₹999.');
        error.mfCartRejected = true;
        throw error;
      }

      const offerLine = before.items.find(isOfferWixoItem);
      const updateKey = offerLine?.key || mfPanditWixoOffer.offerWixoVariantId;
      const previousQuantity = Number(offerLine?.quantity) || 0;
      const payload = {
        updates: { [updateKey]: previousQuantity + quantity },
      };
      if (sectionIds.length) {
        payload.sections = sectionIds.join(',');
        payload.sections_url = window.location.pathname;
      }

      let resource = await updatePanditWixoCart(payload);
      let validation = validatePanditWixoCart(resource);
      if (!validation.ok) {
        resource = await fetchPanditWixoCart();
        validation = validatePanditWixoCart(resource);
      }

      if (!validation.ok) {
        const rollback = {
          updates: { [updateKey]: previousQuantity },
        };
        try {
          const rollbackCart = await updatePanditWixoCart(rollback);
          dispatchFreshPanditWixoCart(rollbackCart);
        } catch (rollbackError) {
          console.error('Mifoa WIXO offer rollback failed:', rollbackError);
        }

        const error = new Error('The ₹999 WIXO offer could not be added. Please try again.');
        error.mfCartRejected = true;
        throw error;
      }

      const itemCount = Number(resource.item_count) || resource.items.reduce(
        (total, item) => total + (Number(item.quantity) || 0),
        0,
      );
      syncPanditWixoOfferUI(resource);
      dispatchCartUpdate(
        resource,
        sourceId || 'mifoa-wixo-offer',
        variantId,
        itemCount,
        resource.sections || {},
        drawer,
        'mifoa-direct-offer-add',
      );
      clearCartSkeleton();
      warmMagicAfterCart();
      return resource;
    } catch (error) {
      clearCartSkeleton();
      throw error;
    }
  };

  document.addEventListener('cart:update', (event) => {
    if (event.detail?.data?.source === 'mifoa-wixo-offer-reconcile') return;
    const resource = event.detail?.resource;
    if (Array.isArray(resource?.items)) syncPanditWixoOfferUI(resource);
    void schedulePanditWixoReconcile(
      Array.isArray(resource?.items) ? resource : null,
      true,
    ).catch(() => {});
  });

  if (document.querySelector('cart-items-component, [data-mf-cart-addon]')) {
    window.setTimeout(
      () => void schedulePanditWixoReconcile(null, false).catch(() => {}),
      0,
    );
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.dataset.mfAjaxSkip === 'true') return;
    const action = form.getAttribute('action') || '';
    if (!/\/cart\/add/.test(action)) return;
    if (form.closest('product-form-component')) {
      showCartSkeleton();
      return;
    }
    event.preventDefault();
    window.__mfAjaxAdd(form, event.submitter);
  }, true);
}

// Razorpay Magic Checkout is needed at checkout, not during the critical
// rendering path of every storefront page. Keep its configuration in the DOM
// and load the integration on cart, account, or payment intent.
function initializeMifoaRazorpayLoader() {
  if (window.__mfRazorpayLoaderReady) return;
  window.__mfRazorpayLoaderReady = true;

  const appendScript = (src, attributes = {}) => new Promise((resolve, reject) => {
    let settled = false;
    const finish = (callback, value) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeout);
      callback(value);
    };
    const timeout = window.setTimeout(
      () => finish(reject, new Error(`Timed out loading ${src}`)),
      12000,
    );
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      const resourceLoaded = performance
        .getEntriesByName(existing.src)
        .some((entry) => entry.responseEnd > 0);
      if (existing.dataset.mfLoadState === 'ready' || resourceLoaded) {
        existing.dataset.mfLoadState = 'ready';
        finish(resolve, existing);
        return;
      }
      existing.addEventListener('load', () => {
        existing.dataset.mfLoadState = 'ready';
        finish(resolve, existing);
      }, { once: true });
      existing.addEventListener('error', (error) => finish(reject, error), { once: true });
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    Object.entries(attributes).forEach(([name, value]) => {
      if (value !== null && value !== undefined) script.setAttribute(name, value);
    });
    script.addEventListener('load', () => {
      script.dataset.mfLoadState = 'ready';
      finish(resolve, script);
    }, { once: true });
    script.addEventListener('error', (error) => finish(reject, error), { once: true });
    document.body.appendChild(script);
  });

  let loadPromise;
  let magicReady = false;
  let magicFailed = false;
  const waitForMagicListener = () => new Promise((resolve, reject) => {
    const startedAt = performance.now();
    const check = () => {
      if (performance.getEntriesByName('listener-attached', 'mark').length) {
        resolve();
        return;
      }
      if (performance.now() - startedAt >= 12000) {
        reject(new Error('Magic Checkout listener did not become ready'));
        return;
      }
      window.setTimeout(check, 50);
    };
    check();
  });
  const load = () => {
    if (loadPromise) return loadPromise;
    document.documentElement.dataset.mfMagicCheckout = 'loading';
    const magicScript = document.getElementById('RazorpayMagicCheckoutConfig')
      ? appendScript('https://magic-plugins.razorpay.com/shopify/magic-shopify.js', { crossorigin: 'anonymous' })
      : Promise.reject(new Error('Magic Checkout configuration is missing'));
    loadPromise = Promise.all([
      magicScript,
      (() => {
        const config = document.getElementById('RazorpayMagicSSOConfigData');
        if (!config) return Promise.resolve();
        const src = 'https://magic-plugins.razorpay.com/shopify-sso/shopify-sso.js';
        if (document.querySelector(`script[src="${src}"]`)) return Promise.resolve();
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.id = 'RazorpayMagicSSOConfig';
        script.textContent = config.textContent;
        document.body.appendChild(script);
        return Promise.resolve(script);
      })(),
    ]).then(async (result) => {
      // The Razorpay bundle performs additional asynchronous setup after its
      // network load event. Its own readiness mark is emitted only after the
      // document checkout listener is attached; do not release or replay a
      // checkout click before that point.
      await waitForMagicListener();
      magicReady = true;
      document.documentElement.dataset.mfMagicCheckout = 'ready';
      return result;
    }).catch((error) => {
      magicFailed = true;
      document.documentElement.dataset.mfMagicCheckout = 'failed';
      throw error;
    });
    return loadPromise;
  };

  window.__mfLoadRazorpay = load;
  const intentSelector = [
    'button[aria-label="Cart"]',
    'a[href*="/cart"]',
    '[name="checkout"]',
    'a[href*="/checkout"]',
    '.shopify-payment-button',
    'shop-login-button',
    'a[href*="/account"]',
  ].join(',');
  const onIntent = (event) => {
    if (event.target instanceof Element && event.target.closest(intentSelector)) {
      void load().catch(() => {});
    }
  };
  document.addEventListener('pointerdown', onIntent, { passive: true, capture: true });
  document.addEventListener('focusin', onIntent, { capture: true });
  document.addEventListener('touchstart', onIntent, { passive: true, capture: true });
  document.addEventListener('cart:update', () => void load().catch(() => {}), { once: true });

  let replayingCheckout = false;
  let checkoutFlight = null;
  const checkoutSelector = 'button[name="checkout"], input[name="checkout"]';

  const findFreshCheckout = (preferDrawer) => {
    const candidates = [...document.querySelectorAll(checkoutSelector)]
      .filter((element) => (
        element instanceof HTMLButtonElement
        || element instanceof HTMLInputElement
      ))
      .filter((element) => !element.disabled);

    return candidates.find((element) => (
      Boolean(element.closest('cart-drawer-component')) === preferDrawer
      && element.offsetParent !== null
    )) || candidates.find((element) => (
      Boolean(element.closest('cart-drawer-component')) === preferDrawer
    )) || candidates.find((element) => element.offsetParent !== null) || candidates[0] || null;
  };

  const releaseCheckout = async (originalCheckout, preferDrawer) => {
    if (typeof window.__mfEnsurePanditWixoOfferReady === 'function') {
      await window.__mfEnsurePanditWixoOfferReady();
    }

    if (!magicReady && !magicFailed) {
      try {
        await load();
      } catch (_error) {
        magicFailed = true;
      }
    }

    // Cart reconciliation can replace the drawer DOM. Always replay on the
    // current checkout control; a detached or disabled button cannot launch
    // Razorpay (and was the cause of the previous no-op).
    const checkout = findFreshCheckout(preferDrawer)
      || (document.contains(originalCheckout) ? originalCheckout : null);
    if (!checkout || checkout.disabled) {
      const error = new Error('Checkout refreshed. Please tap Checkout once more.');
      error.mfCartRejected = true;
      throw error;
    }

    replayingCheckout = true;
    try {
      checkout.click();
    } finally {
      replayingCheckout = false;
    }
  };

  document.addEventListener('click', (event) => {
    if (replayingCheckout) return;

    const target = event.target;
    const checkout = target instanceof Element ? target.closest(checkoutSelector) : null;
    if (!(
      checkout instanceof HTMLButtonElement
      || checkout instanceof HTMLInputElement
    ) || checkout.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutFlight) return;

    const preferDrawer = Boolean(checkout.closest('cart-drawer-component'));
    checkout.setAttribute('aria-busy', 'true');
    checkout.dataset.mfCheckoutPending = 'true';

    checkoutFlight = releaseCheckout(checkout, preferDrawer)
      .catch((error) => {
        if (typeof window.__mfShowPanditWixoStatus === 'function') {
          window.__mfShowPanditWixoStatus(
            error?.message || 'Please retry checkout after the cart finishes updating.',
          );
        }
      })
      .finally(() => {
        const currentCheckout = findFreshCheckout(preferDrawer);
        [checkout, currentCheckout].forEach((element) => {
          if (!element) return;
          element.removeAttribute('aria-busy');
          delete element.dataset.mfCheckoutPending;
        });
        checkoutFlight = null;
      });
  }, { capture: true });

  document.addEventListener('submit', (event) => {
    if (replayingCheckout) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const submitter = event.submitter;
    const checkout = (
      submitter instanceof HTMLButtonElement
      || submitter instanceof HTMLInputElement
    ) && submitter.name === 'checkout'
      ? submitter
      : form.querySelector(checkoutSelector);
    if (!(
      checkout instanceof HTMLButtonElement
      || checkout instanceof HTMLInputElement
    ) || checkout.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    checkout.click();
  }, { capture: true });

  const template = document.querySelector('#MainContent')?.dataset.template || '';
  if (template === 'cart') window.setTimeout(() => void load().catch(() => {}), 250);
}

// Honest review stars: grey the decorative gold stars next to [data-mf-review-rating]
// until a real rating value is present. Re-checks after load (Doran hydrates late).
function initializeMifoaStars() {
  const apply = () => {
    document.querySelectorAll('[data-mf-review-rating]').forEach((r) => {
      const row = r.previousElementSibling;
      if (!row || row.querySelectorAll('svg').length < 3) return;
      const val = parseFloat((r.textContent || '').replace(/[^0-9.]/g, ''));
      const live = Number.isFinite(val) && val > 0;
      row.style.filter = live ? '' : 'grayscale(1)';
      row.style.opacity = live ? '' : '0.3';
    });
  };
  apply();
  window.addEventListener('load', apply, { once: true });
  window.setTimeout(apply, 2500);
}


// mifoa PDP micro-demos — ported from the offline design interaction logic.
// SWAYO take-a-turn · TUGLO reel mechanism · PIXO colour cycle ·
// PICKQ press-to-serve · FUELO fill/clip/go · STRAPO strap-on sequence.
function initializeMifoaProductDemos(root = document) {
  const reduce = () => prefersReducedMotion.matches;
  const frames = new Set();
  ['[data-turn]', '[data-mech]', '[data-color-play]', '[data-press-go]', '[data-step]', '[data-strap-ring]'].forEach((sel) => {
    root.querySelectorAll(sel).forEach((el) => {
      const frame = el.closest('.mf-source-layout') || el.closest('.mf-editable-module');
      if (frame) frames.add(frame);
    });
  });

  frames.forEach((frame) => {
    // ---- SWAYO · take a turn ----
    if (frame.querySelector('[data-turn]') && !frame.dataset.mfTurnReady) {
      frame.dataset.mfTurnReady = 'true';
      const bear = frame.querySelector('[data-bear]');
      const cap = frame.querySelector('[data-demo-caption]');
      const btns = [...frame.querySelectorAll('[data-turn]')];
      const caps = { left: 'GLIDING LEFT · silent, mark-free', center: 'CENTRED · gentle idle sway', right: 'GLIDING RIGHT · silent, mark-free' };
      const offs = { left: -90, center: 0, right: 90 };
      btns.forEach((b) => b.addEventListener('click', () => {
        const k = b.getAttribute('data-turn');
        btns.forEach((x) => { const on = x === b; x.style.background = on ? '#3B49BE' : 'transparent'; x.style.color = on ? '#fff' : '#C9CEDC'; x.style.borderColor = on ? '#3B49BE' : '#3A3F4E'; x.style.borderWidth = on ? '1.5px' : '1px'; });
        if (bear) {
          bear.classList.remove('mfSwayIdle');
          if (reduce()) { bear.style.transform = 'translateX(' + offs[k] + 'px)'; }
          else {
            bear.style.transform = 'translateX(' + offs[k] + 'px) rotate(' + (k === 'center' ? 0 : (k === 'left' ? -4 : 4)) + 'deg)';
            if (k === 'center') window.setTimeout(() => { bear.style.transform = ''; bear.classList.add('mfSwayIdle'); }, 400);
          }
        }
        if (cap && caps[k]) cap.textContent = caps[k];
      }));
    }

    // ---- TUGLO · reel mechanism ----
    if (frame.querySelector('[data-mech]') && !frame.dataset.mfMechReady) {
      frame.dataset.mfMechReady = 'true';
      const wire = frame.querySelector('[data-wire]');
      const carrier = frame.querySelector('[data-carrier]');
      const readout = frame.querySelector('[data-mech-readout]');
      const cap = frame.querySelector('[data-mech-caption]');
      const mechBtns = [...frame.querySelectorAll('[data-mech]')];
      let mechTimer = null;
      const paint = (activeKind) => mechBtns.forEach((b) => { const on = b.getAttribute('data-mech') === activeKind; b.style.background = on ? '#3B49BE' : 'transparent'; b.style.color = on ? '#fff' : '#C9CEDC'; b.style.borderColor = on ? '#3B49BE' : '#3A3F4E'; b.style.borderWidth = on ? '1.5px' : '1px'; });
      const retract = () => {
        if (wire) wire.style.height = '24px';
        if (carrier) carrier.style.transform = 'translateX(-50%) translateY(-50%)';
        if (readout) readout.innerHTML = '0<span style="font-size:20px;color:#9AA2B7;"> cm</span>';
        if (cap) cap.textContent = 'COIL-SPRING AUTO-RETURN';
        paint(null);
        window.setTimeout(() => { if (cap && wire && wire.style.height === '24px') cap.textContent = 'CLIPPED & READY'; }, 1100);
      };
      const extend = () => {
        const maxH = 190;
        if (wire) wire.style.height = maxH + 'px';
        if (carrier) carrier.style.transform = 'translateX(-50%) translateY(-50%) translateY(' + (maxH - 24) + 'px)';
        if (readout) readout.innerHTML = '60<span style="font-size:20px;color:#9AA2B7;"> cm</span>';
        if (cap) cap.textContent = 'FULL REACH · 60 cm';
        paint('pull');
        window.clearTimeout(mechTimer);
        mechTimer = window.setTimeout(retract, reduce() ? 2600 : 1600);
      };
      mechBtns.forEach((b) => b.addEventListener('click', () => {
        if (b.getAttribute('data-mech') === 'pull') extend();
        else { window.clearTimeout(mechTimer); retract(); }
      }));
    }

    // ---- PIXO · colour cycle ----
    if (frame.querySelector('[data-color-play]') && !frame.dataset.mfColorReady) {
      frame.dataset.mfColorReady = 'true';
      const COLORS = [
        { n: 'Coral', h: '#FF5D6C' }, { n: 'Red', h: '#EF3E4A' }, { n: 'Orange', h: '#FF7A3D' }, { n: 'Amber', h: '#F5A623' },
        { n: 'Yellow', h: '#FFD23F' }, { n: 'Lime', h: '#A3E635' }, { n: 'Green', h: '#34C759' }, { n: 'Teal', h: '#14B8A6' },
        { n: 'Cyan', h: '#22D3EE' }, { n: 'Sky', h: '#38BDF8' }, { n: 'Blue', h: '#3B82F6' }, { n: 'Indigo', h: '#5A6BF0' },
        { n: 'Purple', h: '#8B5CF6' }, { n: 'Magenta', h: '#D6409F' }, { n: 'Pink', h: '#FF6FB5' }, { n: 'Warm White', h: '#FBE7C6' }
      ];
      const hexToRgb = (h) => { const m = h.replace('#', ''); return [parseInt(m.slice(0, 2), 16), parseInt(m.slice(2, 4), 16), parseInt(m.slice(4, 6), 16)]; };
      const swWrap = frame.querySelector('[data-swatches]');
      const glow = frame.querySelector('[data-color-glow]');
      const ambient = frame.querySelector('[data-color-ambient]');
      const cName = frame.querySelector('[data-color-name]');
      const cIndex = frame.querySelector('[data-color-index]');
      const cDot = frame.querySelector('[data-color-dot]');
      const playBtn = frame.querySelector('[data-color-play]');
      const playLabel = frame.querySelector('[data-play-label]');
      const playIcon = frame.querySelector('[data-play-icon]');
      let ci = 0;
      let timer = null;
      const setColor = (i) => {
        ci = (i + COLORS.length) % COLORS.length;
        const c = COLORS[ci];
        const rgb = hexToRgb(c.h);
        const r = rgb[0]; const g = rgb[1]; const b = rgb[2];
        if (glow) glow.style.background = 'radial-gradient(closest-side at 50% 48%,rgba(' + r + ',' + g + ',' + b + ',.85),rgba(' + r + ',' + g + ',' + b + ',.18) 55%,transparent 74%)';
        if (ambient) ambient.style.background = 'radial-gradient(closest-side,rgba(' + r + ',' + g + ',' + b + ',.42),transparent 72%)';
        if (cName) cName.textContent = c.n;
        if (cIndex) cIndex.textContent = String(ci + 1).padStart(2, '0');
        if (cDot) { cDot.style.background = c.h; cDot.style.boxShadow = '0 0 18px rgba(' + r + ',' + g + ',' + b + ',.7)'; }
        if (swWrap) swWrap.querySelectorAll('[data-swatch]').forEach((s) => { const on = parseInt(s.getAttribute('data-swatch'), 10) === ci; s.style.boxShadow = on ? '0 0 0 2px #14161F, 0 0 0 4px #FBFCFE' : 'none'; s.style.transform = on ? 'translateY(-2px)' : 'none'; });
      };
      const stop = () => {
        if (timer) { window.clearInterval(timer); timer = null; }
        if (playIcon) playIcon.innerHTML = '<path d="M8 5v14l11-7z"/>';
        if (playLabel) playLabel.textContent = 'Run the cycle';
      };
      const start = () => {
        if (reduce()) { setColor(ci + 1); return; }
        if (playIcon) playIcon.innerHTML = '<rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/>';
        if (playLabel) playLabel.textContent = 'Pause';
        timer = window.setInterval(() => setColor(ci + 1), 900);
      };
      if (swWrap && !swWrap.childElementCount) {
        COLORS.forEach((c, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'mfSwatch';
          b.setAttribute('data-swatch', String(i));
          b.setAttribute('aria-label', c.n);
          b.style.aspectRatio = '1/1'; b.style.background = c.h; b.style.minHeight = '30px';
          b.style.border = '0'; b.style.borderRadius = '9px'; b.style.cursor = 'pointer';
          b.addEventListener('click', () => { stop(); setColor(i); });
          swWrap.appendChild(b);
        });
      }
      if (playBtn) playBtn.addEventListener('click', () => { if (timer) stop(); else start(); });
      setColor(0);
    }

    // ---- PICKQ · press-to-serve ----
    if (frame.querySelector('[data-press-go]') && !frame.dataset.mfPressReady) {
      frame.dataset.mfPressReady = 'true';
      const pk = frame.querySelector('[data-press-toothpick]');
      const cover = frame.querySelector('[data-press-cover]');
      const readout = frame.querySelector('[data-press-readout]');
      const cap = frame.querySelector('[data-press-caption]');
      const hint = frame.querySelector('[data-press-hint]');
      const steps = [...frame.querySelectorAll('[data-pstep]')];
      const goBtn = frame.querySelector('[data-press-go]');
      const resetBtn = frame.querySelector('[data-press-reset]');
      let served = 0;
      let timers = [];
      const clearT = () => { timers.forEach(window.clearTimeout); timers = []; };
      const lit = (n) => steps.forEach((s) => { const on = parseInt(s.getAttribute('data-pstep'), 10) <= n && n > 0; s.style.background = on ? '#3B49BE' : 'transparent'; s.style.borderColor = on ? '#3B49BE' : '#DCE1EC'; s.style.color = on ? '#fff' : '#8B93A5'; });
      if (goBtn) goBtn.addEventListener('click', () => {
        const rm = reduce();
        clearT(); served += 1;
        if (hint) hint.style.opacity = '0';
        if (cover) cover.style.transform = 'translateY(3px)';
        if (pk) { pk.style.transition = rm ? 'none' : 'transform .5s cubic-bezier(.34,1.45,.5,1)'; pk.style.transform = 'translateY(-54px)'; }
        lit(1); if (readout) readout.textContent = 'PRESS'; if (cap) cap.textContent = '01 · PRESS THE TOP';
        timers.push(window.setTimeout(() => { if (cover) cover.style.transform = 'translateY(0)'; lit(2); if (readout) readout.textContent = 'PICK'; if (cap) cap.textContent = '02 · ONE CLEAN PICK RISES'; }, rm ? 0 : 480));
        timers.push(window.setTimeout(() => { lit(3); if (readout) readout.textContent = 'DONE'; if (cap) cap.textContent = '03 · TAKE IT · ' + served + ' SERVED'; }, rm ? 0 : 1350));
        timers.push(window.setTimeout(() => { if (pk) { pk.style.transition = 'transform .4s ease'; pk.style.transform = 'translateY(0)'; } if (readout) readout.textContent = 'READY'; if (cap) cap.textContent = 'COVERED · CLEAN · READY'; lit(0); }, rm ? 900 : 2500));
      });
      if (resetBtn) resetBtn.addEventListener('click', () => {
        clearT(); served = 0;
        if (pk) { pk.style.transition = 'transform .3s ease'; pk.style.transform = 'translateY(0)'; }
        if (cover) cover.style.transform = 'translateY(0)';
        if (hint) hint.style.opacity = '.7';
        if (readout) readout.textContent = 'READY'; if (cap) cap.textContent = 'COVERED · CLEAN · READY'; lit(0);
      });
    }

    // ---- FUELO · fill / clip / go ----
    if (frame.querySelector('[data-step="fill"]') && !frame.dataset.mfStepReady) {
      frame.dataset.mfStepReady = 'true';
      const stepBtns = [...frame.querySelectorAll('[data-step]')];
      const dots = [...frame.querySelectorAll('[data-dot]')];
      const cap = frame.querySelector('[data-demo-caption]');
      const body = frame.querySelector('[data-demo-body]');
      const STEPS = ['fill', 'clip', 'go'];
      const STEP_COPY = {
        fill: { cap: 'STEP 01 / 03', body: 'Unscrew the top cap and tip in one scoop of protein, creatine or pre-workout.' },
        clip: { cap: 'STEP 02 / 03', body: 'Screw both ends shut and clip it to your gym bag, backpack or keys.' },
        go: { cap: 'STEP 03 / 03', body: 'Grab it on the way out. Mix a fresh serving whenever you get there.' }
      };
      let autoIdx = 0;
      const setStep = (kind) => {
        const gi = STEPS.indexOf(kind);
        if (gi < 0) return;
        autoIdx = gi;
        stepBtns.forEach((s) => {
          const on = s.getAttribute('data-step') === kind;
          s.style.background = on ? '#3B49BE' : 'transparent'; s.style.color = on ? '#fff' : '#C9CEDC';
          s.style.borderColor = on ? '#3B49BE' : '#3A3F4E'; s.style.borderWidth = on ? '1.5px' : '1px';
          const num = s.querySelector('[data-step-num]');
          if (num) num.style.background = on ? 'rgba(255,255,255,.16)' : '#2A2E3C';
        });
        dots.forEach((d) => { d.style.background = (parseInt(d.getAttribute('data-dot'), 10) <= gi) ? '#3B49BE' : '#2A2E3C'; });
        if (cap) cap.textContent = STEP_COPY[kind].cap;
        if (body) body.textContent = STEP_COPY[kind].body;
      };
      stepBtns.forEach((s) => s.addEventListener('click', () => setStep(s.getAttribute('data-step'))));
      const demoPlay = frame.querySelector('[data-demo-play]');
      if (demoPlay) demoPlay.addEventListener('click', () => setStep(STEPS[(autoIdx + 1) % 3]));
      setStep('fill');
    }

    // ---- STRAPO · loop / hook / locked ----
    if (frame.querySelector('[data-strap-ring]') && !frame.dataset.mfStrapReady) {
      frame.dataset.mfStrapReady = 'true';
      const ring = frame.querySelector('[data-strap-ring]');
      const band = frame.querySelector('[data-strap-band]');
      const bag = frame.querySelector('[data-demo-bag]');
      const cap = frame.querySelector('[data-demo-caption]');
      const readout = frame.querySelector('[data-demo-readout]');
      const note = frame.querySelector('[data-demo-note]');
      const steps = [...frame.querySelectorAll('[data-step]')].filter((s) => /^[0-9]+$/.test(s.getAttribute('data-step') || ''));
      const playBtn = frame.querySelector('[data-demo-play]');
      const resetBtn = frame.querySelector('[data-demo-reset]');
      let timers = [];
      let tick = null;
      const setStep = (n) => steps.forEach((s) => { const on = parseInt(s.getAttribute('data-step'), 10) <= n && n > 0; s.style.background = on ? '#3B49BE' : 'transparent'; s.style.color = on ? '#fff' : '#9AA2B7'; s.style.borderColor = on ? '#3B49BE' : '#3A3F4E'; });
      const setReadout = (v) => { if (readout) readout.innerHTML = v.toFixed(1) + '<span style="font-size:20px;color:#9AA2B7;"> s</span>'; };
      const rest = () => {
        timers.forEach(window.clearTimeout); timers = [];
        if (tick) { window.clearInterval(tick); tick = null; }
        if (ring) ring.style.transform = 'translateX(-50%)';
        if (band) band.style.height = '0px';
        if (bag) bag.style.transform = 'translateX(0)';
        if (cap) cap.textContent = 'TWO BAGS · NO SPARE HAND';
        if (note) note.style.opacity = '0';
        setReadout(0); setStep(0);
      };
      const play = () => {
        rest();
        if (reduce()) {
          if (ring) ring.style.transform = 'translateX(-50%) translateY(38px)';
          if (band) band.style.height = '150px';
          if (bag) bag.style.transform = 'translateX(-46px)';
          if (cap) cap.textContent = '03 · LOCKED FLAT — HANDS FREE';
          if (note) note.style.opacity = '1';
          setReadout(3); setStep(3);
          return;
        }
        const t0 = Date.now();
        setStep(1);
        if (cap) cap.textContent = '01 · LOOP THE RING OVER THE HANDLE';
        if (ring) ring.style.transform = 'translateX(-50%) translateY(38px)';
        tick = window.setInterval(() => { const t = Math.min(3, (Date.now() - t0) / 1000); setReadout(t); if (t >= 3 && tick) { window.clearInterval(tick); tick = null; } }, 100);
        timers.push(window.setTimeout(() => { setStep(2); if (cap) cap.textContent = '02 · STRETCH & HOOK UNDER THE BAG'; if (band) band.style.height = '150px'; }, 1000));
        timers.push(window.setTimeout(() => { setStep(3); if (cap) cap.textContent = '03 · LOCKED FLAT — HANDS FREE'; if (bag) bag.style.transform = 'translateX(-46px)'; }, 2000));
        timers.push(window.setTimeout(() => { if (note) note.style.opacity = '1'; }, 2700));
      };
      if (playBtn) playBtn.addEventListener('click', play);
      if (resetBtn) resetBtn.addEventListener('click', rest);
    }
  });
}

function initializeMifoaMobileNavPortal() {
  const ensurePortal = () => {
    const nav = document.querySelector('details.mf-mobile-nav');
    if (!nav) return null;
    const inner = nav.querySelector('.mf-mobile-nav__panel');
    if (inner) {
      document.querySelectorAll('body > .mf-mobile-nav__panel[data-mf-portaled]').forEach((old) => old.remove());
      inner.setAttribute('data-mf-portaled', 'true');
      document.body.appendChild(inner);
    }
    return document.querySelector('body > .mf-mobile-nav__panel[data-mf-portaled]');
  };
  const sync = () => {
    const nav = document.querySelector('details.mf-mobile-nav');
    const panel = ensurePortal();
    if (!nav || !panel) return;
    panel.classList.toggle('is-open', nav.open);
    nav.querySelector('summary')?.setAttribute('aria-expanded', String(nav.open));
    document.documentElement.classList.toggle('mf-mobile-nav-open', nav.open);
  };
  const nav = document.querySelector('details.mf-mobile-nav');
  if (nav && nav.dataset.mfNavPortalBound !== 'true') {
    nav.dataset.mfNavPortalBound = 'true';
    nav.addEventListener('toggle', sync);
  }
  if (document.documentElement.dataset.mfNavPortalDelegated !== 'true') {
    document.documentElement.dataset.mfNavPortalDelegated = 'true';
    document.addEventListener('toggle', (event) => {
      const el = event.target;
      if (el && el.matches && el.matches('details.mf-mobile-nav')) sync();
    }, true);
  }
  sync();
}

function initializeMifoaBonesDemo(root = document) {
  const reduce = () => { try { return window.matchMedia('(prefers-reduced-motion:reduce)').matches; } catch (e) { return false; } };
  root.querySelectorAll('[data-bones]:not([data-bones-ready])').forEach((bones) => {
    bones.dataset.bonesReady = 'true';
    const scope = bones.closest('.mf-source-layout') || document;
    const box = bones.parentElement;
    const cord = box.querySelector('[data-cord]');
    const ring = box.querySelector('[data-ring]');
    const ping = box.querySelector('[data-ring-ping]');
    const armL = bones.querySelector('[data-arm-l]'), armR = bones.querySelector('[data-arm-r]');
    const legL = bones.querySelector('[data-leg-l]'), legR = bones.querySelector('[data-leg-r]');
    const jaw = bones.querySelector('[data-jaw]'), skull = bones.querySelector('[data-skull]');
    const countEl = scope.querySelector('[data-pull-count]');
    const quipEl = scope.querySelector('[data-pull-quip]');
    const REST = [[armL, 'rotate(10deg)'], [armR, 'rotate(-10deg)'], [legL, 'rotate(6deg)'], [legR, 'rotate(-6deg)'], [jaw, 'translateY(0px)'], [skull, 'rotate(0deg)']];
    const setTrans = (tr) => REST.forEach(([el]) => { if (el) el.style.transition = tr; });
    const setRest = () => REST.forEach(([el, v]) => { if (el) el.style.transform = v; });
    const setPull = (t) => {
      if (armL) armL.style.transform = 'rotate(' + (10 + 108 * t) + 'deg)';
      if (armR) armR.style.transform = 'rotate(' + (-10 - 108 * t) + 'deg)';
      if (legL) legL.style.transform = 'rotate(' + (6 + 40 * t) + 'deg)';
      if (legR) legR.style.transform = 'rotate(' + (-6 - 40 * t) + 'deg)';
      if (jaw) jaw.style.transform = 'translateY(' + (7 * t) + 'px)';
      if (skull) skull.style.transform = 'rotate(' + (-3 * t) + 'deg)';
    };
    const QUIPS = ['That\u2019s one.', 'Two. Feeling it?', 'Three. It\u2019s not you \u2014 it\u2019s the cord.', 'Four. Solid form.', 'Five. Told you.', 'Six. He\u2019s warmed up now.', 'Seven. The scroll never stood a chance.'];
    let pulls = 0, busy = false, startY = null, dy = 0;
    const springBack = () => {
      if (cord) { cord.style.transition = 'height .32s cubic-bezier(.3,1.3,.5,1)'; cord.style.height = '96px'; }
      if (ring) { ring.style.transition = 'transform .32s cubic-bezier(.3,1.3,.5,1)'; ring.style.transform = 'translateY(0)'; }
    };
    const fire = () => {
      if (busy) return; busy = true; pulls += 1;
      if (ping) ping.style.display = 'none';
      if (countEl) countEl.textContent = String(pulls).padStart(2, '0');
      if (quipEl) quipEl.textContent = pulls <= QUIPS.length ? QUIPS[pulls - 1] : (pulls % 5 === 0 ? 'Still identical. Every pull hits the same.' : 'Okay. Take him home.');
      springBack();
      if (reduce()) { setTrans('none'); setRest(); busy = false; return; }
      setTrans('none');
      bones.classList.add('bnGo');
      setTimeout(() => { bones.classList.remove('bnGo'); setTrans('none'); setRest(); busy = false; }, 1000);
    };
    if (!ring) return;
    ring.addEventListener('pointerdown', (e) => { if (busy) return; startY = e.clientY; dy = 0; try { ring.setPointerCapture(e.pointerId); } catch (err) {} if (cord) cord.style.transition = 'none'; ring.style.transition = 'none'; setTrans('none'); ring.style.cursor = 'grabbing'; e.preventDefault(); });
    ring.addEventListener('pointermove', (e) => { if (startY === null) return; dy = Math.max(0, Math.min(96, e.clientY - startY)); if (cord) cord.style.height = (96 + dy) + 'px'; ring.style.transform = 'translateY(' + dy + 'px)'; setPull(dy / 96); });
    const release = () => { if (startY === null) return; startY = null; ring.style.cursor = 'grab'; if (dy > 34) { fire(); } else { springBack(); setTrans('transform .3s ease'); setRest(); } dy = 0; };
    ring.addEventListener('pointerup', release);
    ring.addEventListener('pointercancel', release);
    ring.setAttribute('tabindex', '0');
    ring.setAttribute('role', 'button');
    ring.setAttribute('aria-label', 'Pull the cord');
    ring.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      if (busy) return;
      setTrans('none');
      setPull(1);
      if (cord) { cord.style.transition = 'height .12s ease'; cord.style.height = '176px'; }
      ring.style.transition = 'transform .12s ease';
      ring.style.transform = 'translateY(80px)';
      setTimeout(fire, 140);
    });
  });

  root.querySelectorAll('[data-add-pair]:not([data-source-ready])').forEach((btn) => {
    btn.dataset.sourceReady = 'true';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const opts = document.querySelectorAll('[data-buy-opt]');
      const two = [...opts].find((o) => (o.dataset.buyOpt || o.getAttribute('data-buy-opt')) === '2') || opts[1];
      if (two) two.click();
      const form = document.querySelector('.mf-source-product-form');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
}

function initializeMifoaCupdeckDemos(root = document) {
  const reduce = () => { try { return window.matchMedia('(prefers-reduced-motion:reduce)').matches; } catch (e) { return false; } };

  // ===== TWIST-LOCK: twist to grip + drag arm to tilt + pothole test =====
  root.querySelectorAll('[data-dial]:not([data-cd-ready])').forEach((dial) => {
    dial.dataset.cdReady = 'true';
    const scope = dial.closest('.mf-source-layout') || document;
    const face = scope.querySelector('[data-dial-face]');
    const fill = scope.querySelector('[data-grip-fill]');
    const jaws = scope.querySelectorAll('[data-grip-jaw]');
    const lockBadge = scope.querySelector('[data-lock-badge]');
    const lockPing = scope.querySelector('[data-lock-ping]');
    const cap = scope.querySelector('[data-twist-cap]');
    const twistBtn = scope.querySelector('[data-twist-btn]');
    const potBtn = scope.querySelector('[data-pothole]');
    let grip = 0, locked = false;
    const render = () => {
      const g = Math.max(0, Math.min(100, grip));
      if (face) face.style.transform = 'rotate(' + (g * 2.7) + 'deg)';
      if (fill) fill.style.width = g + '%';
      jaws.forEach((j) => { const dir = j.getAttribute('data-grip-jaw') === 'l' ? -1 : 1; j.style.transform = 'translateX(' + (dir * (g / 100) * 13) + 'px)'; });
      dial.setAttribute('aria-valuenow', String(Math.round(g)));
      if (cap) cap.textContent = g < 5 ? 'DROP IT IN' : (g < 80 ? 'TWISTING… collar gripping' : 'LOCKED · won’t budge');
      const now = g >= 80;
      if (now !== locked) {
        locked = now;
        if (lockBadge) { lockBadge.style.opacity = locked ? '1' : '0'; lockBadge.style.transform = 'translateX(-50%) ' + (locked ? 'scale(1)' : 'scale(.8)'); }
        if (locked) {
          if (lockPing && lockPing.animate && !reduce()) { lockPing.style.opacity = '1'; lockPing.animate([{ transform: 'scale(.65)', opacity: .85 }, { transform: 'scale(2.2)', opacity: 0 }], { duration: 600, easing: 'ease-out' }); setTimeout(() => { if (lockPing) lockPing.style.opacity = '0'; }, 600); }
          if (potBtn) { potBtn.style.borderColor = '#3B49BE'; potBtn.style.color = '#fff'; potBtn.style.background = '#3B49BE'; }
        } else if (potBtn) { potBtn.style.borderColor = '#3A3F4E'; potBtn.style.color = '#C9CEDC'; potBtn.style.background = 'transparent'; }
      }
    };
    let dragging = false, lastAng = 0;
    const angOf = (e) => { const r = dial.getBoundingClientRect(); return Math.atan2(e.clientY - (r.top + r.height / 2), e.clientX - (r.left + r.width / 2)); };
    dial.addEventListener('pointerdown', (e) => { dragging = true; lastAng = angOf(e); try { dial.setPointerCapture(e.pointerId); } catch (_) {} e.preventDefault(); });
    dial.addEventListener('pointermove', (e) => { if (!dragging) return; const a = angOf(e); let d = a - lastAng; if (d > Math.PI) d -= 2 * Math.PI; if (d < -Math.PI) d += 2 * Math.PI; lastAng = a; grip = Math.max(0, Math.min(100, grip + d * (180 / Math.PI) * 0.9)); render(); });
    const end = (e) => { dragging = false; try { dial.releasePointerCapture(e.pointerId); } catch (_) {} };
    dial.addEventListener('pointerup', end); dial.addEventListener('pointercancel', end);
    dial.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { grip = Math.min(100, grip + 12); render(); e.preventDefault(); } else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { grip = Math.max(0, grip - 12); render(); e.preventDefault(); } });
    if (twistBtn) twistBtn.addEventListener('click', () => {
      if (reduce()) { grip = grip >= 80 ? 0 : 100; render(); return; }
      const start = grip, target = grip >= 80 ? 0 : 100, t0 = performance.now(), dur = 850;
      const step = (t) => { const k = Math.min(1, (t - t0) / dur); grip = start + (target - start) * (1 - Math.pow(1 - k, 3)); render(); if (k < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    });
    // pothole test
    const rig = scope.querySelector('[data-rig]');
    const rig2 = scope.querySelector('[data-rig-2]');
    const potCap = scope.querySelector('[data-pothole-cap]');
    const chaiSteam = scope.querySelector('[data-chai-steam]');
    if (potBtn) potBtn.addEventListener('click', () => {
      if (grip < 80) { if (potCap) { potCap.textContent = 'Twist to lock first ↑'; potCap.style.color = '#EBB758'; } return; }
      if (potCap) { potCap.textContent = 'Stayed put. Nothing spilled.'; potCap.style.color = '#6EE7B7'; }
      if (reduce()) return;
      const jolt = [{ transform: 'translate(0,0)' }, { transform: 'translate(-3px,5px)' }, { transform: 'translate(4px,-3px)' }, { transform: 'translate(-2px,4px)' }, { transform: 'translate(3px,-2px)' }, { transform: 'translate(0,0)' }];
      [rig, rig2].forEach((r) => { if (r && r.animate) r.animate(jolt, { duration: 560, easing: 'ease-in-out' }); });
      if (chaiSteam && chaiSteam.animate) chaiSteam.animate([{ opacity: .6 }, { opacity: .9 }, { opacity: .6 }], { duration: 560 });
    });
    render();
  });

  // ===== ARM: drag to tilt =====
  root.querySelectorAll('[data-arm]:not([data-cd-ready])').forEach((arm) => {
    arm.dataset.cdReady = 'true';
    const scope = arm.closest('.mf-source-layout') || document;
    const wrap = scope.querySelector('[data-arm-wrap]');
    const cap = scope.querySelector('[data-arm-cap]');
    if (!wrap) return;
    let dragging = false, startY = 0, angle = 0, startA = 0, touched = false;
    const render = () => { wrap.style.transform = 'rotate(' + angle + 'deg)'; if (cap && touched) cap.textContent = 'LOCKED @ ' + (angle > 2 ? '+' : '') + Math.round(angle) + '°'; };
    arm.addEventListener('pointerdown', (e) => { dragging = true; touched = true; startY = e.clientY; startA = angle; try { arm.setPointerCapture(e.pointerId); } catch (_) {} e.preventDefault(); });
    arm.addEventListener('pointermove', (e) => { if (!dragging) return; angle = Math.max(-32, Math.min(32, startA + (e.clientY - startY) * 0.4)); render(); });
    const end = (e) => { dragging = false; try { arm.releasePointerCapture(e.pointerId); } catch (_) {} };
    arm.addEventListener('pointerup', end); arm.addEventListener('pointercancel', end);
    arm.addEventListener('keydown', (e) => { if (e.key === 'ArrowUp') { touched = true; angle = Math.max(-32, angle - 4); render(); e.preventDefault(); } else if (e.key === 'ArrowDown') { touched = true; angle = Math.min(32, angle + 4); render(); e.preventDefault(); } });
    render();
  });

  // ===== FIT CHECKER =====
  root.querySelectorAll('[data-fit-track]:not([data-cd-ready])').forEach((track) => {
    track.dataset.cdReady = 'true';
    const scope = track.closest('.mf-source-layout') || document;
    const handle = scope.querySelector('[data-fit-handle]');
    if (!handle) return;
    const mmEl = scope.querySelector('[data-fit-mm]');
    const verdict = scope.querySelector('[data-fit-verdict]');
    const help = scope.querySelector('[data-fit-help]');
    const presets = scope.querySelectorAll('[data-fit-preset]');
    const MIN = 60, MAX = 105;
    let val = 80;
    const setVerdict = (fits) => {
      if (!verdict) return;
      if (fits) { verdict.style.background = '#E7F3ED'; verdict.style.color = '#1E5C42'; verdict.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1E5C42" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>Fits — locks tight'; }
      else { verdict.style.background = '#FCF3E1'; verdict.style.color = '#7E5210'; verdict.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#7E5210" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/></svg>Outside 65–100 mm'; }
    };
    const render = () => {
      const k = (val - MIN) / (MAX - MIN);
      handle.style.left = (k * 100) + '%';
      if (mmEl) mmEl.textContent = String(val);
      handle.setAttribute('aria-valuenow', String(val));
      const fits = val >= 65 && val <= 100;
      setVerdict(fits);
      if (help) { help.textContent = fits ? 'Most Indian cars sit between 72 and 90 mm — comfortably inside the range. Not sure? Measure the opening across the top; we’ll help on WhatsApp.' : 'That’s just outside CupDeck’s 65–100 mm range. Message us your holder size on WhatsApp and we’ll tell you straight whether it’ll grip.'; }
    };
    const fromX = (clientX) => { const r = track.getBoundingClientRect(); const k = Math.max(0, Math.min(1, (clientX - r.left) / r.width)); return Math.round(MIN + k * (MAX - MIN)); };
    let dragging = false;
    handle.addEventListener('pointerdown', (e) => { dragging = true; try { handle.setPointerCapture(e.pointerId); } catch (_) {} e.preventDefault(); });
    handle.addEventListener('pointermove', (e) => { if (!dragging) return; val = fromX(e.clientX); render(); });
    const end = (e) => { dragging = false; try { handle.releasePointerCapture(e.pointerId); } catch (_) {} };
    handle.addEventListener('pointerup', end); handle.addEventListener('pointercancel', end);
    track.addEventListener('pointerdown', (e) => { if (e.target === handle) return; val = fromX(e.clientX); render(); });
    handle.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { val = Math.min(MAX, val + 1); render(); e.preventDefault(); } else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { val = Math.max(MIN, val - 1); render(); e.preventDefault(); } });
    presets.forEach((p) => p.addEventListener('click', () => { val = parseInt(p.getAttribute('data-fit-preset'), 10); presets.forEach((x) => { const on = x === p; x.style.background = on ? '#EDEFFC' : '#fff'; x.style.borderColor = on ? '#3B49BE' : '#DCE1EC'; x.style.color = on ? '#303C9E' : '#363D52'; }); render(); }));
    render();
  });

  // ===== SWIVEL-ASIDE toggle =====
  root.querySelectorAll('[data-swivel]:not([data-cd-ready])').forEach((btn) => {
    btn.dataset.cdReady = 'true';
    const scope = btn.closest('.mf-source-layout') || document;
    const swArm = scope.querySelector('[data-swivel-arm]');
    if (!swArm) return;
    let aside = false;
    btn.addEventListener('click', () => { aside = !aside; swArm.style.transform = aside ? 'rotate(-74deg)' : 'rotate(0deg)'; btn.textContent = aside ? 'Bring it back' : 'Swing it aside'; });
  });
}

function initializeMifoaHeaderVar() {
  if (document.documentElement.dataset.mfHeaderVarReady === 'true') return;
  document.documentElement.dataset.mfHeaderVarReady = 'true';
  const group = document.querySelector('#header-group, .shopify-section-group-header-group, header-component, .header')?.closest('.shopify-section') || document.querySelector('.shopify-section:has(header)');
  const el = group || document.querySelector('header');
  if (!el) return;
  let frame = 0;
  let lastBottom = -1;
  const setVar = () => {
    frame = 0;
    const rect = el.getBoundingClientRect();
    const bottom = Math.round(Math.max(0, rect.bottom));
    if (bottom === lastBottom) return;
    lastBottom = bottom;
    document.documentElement.style.setProperty('--mf-header-bottom', bottom + 'px');
  };
  const schedule = () => {
    if (!frame) frame = window.requestAnimationFrame(setVar);
  };
  schedule();
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(el);
}

function initializeMifoa(root = document) {
  initializeSourceDesigns(root);
  initializeMifoaReveals(root);
  initializeMifoaHero(root);
  initializeSoundDemo(root);
  initializeMifoaProductDemos(root);
  initializeMoxiGame(root);
  initializeBuyBox(root);
  initializeDoranSummary();
  initializeMifoaCartAjax();
  initializeMifoaRazorpayLoader();
  initializeMifoaStars();
  initializeMifoaHeaderVar();
  initializeMifoaBonesDemo(root);
  initializeMifoaCupdeckDemos(root);
  initializeMifoaMobileNavPortal();
}

function initializeDoranSummary() {
  const page = document.documentElement;
  if (page.dataset.mfDoranSummaryReady === 'true') return;
  if (!document.querySelector('[data-mf-review-rating], [data-mf-review-count]')) return;
  page.dataset.mfDoranSummaryReady = 'true';
  // Approved Doran aggregates are rendered from product metafields in Liquid.
  // Do not poll the lower-page iframe when the title summary is already complete.
  if (document.querySelector('[data-mf-review-server="true"]')) return;

  let attempts = 0;
  const sync = () => {
    attempts += 1;
    const frame = document.querySelector('#doran-product-widget iframe');
    let text = '';
    try {
      text = frame?.contentDocument?.body?.innerText || '';
    } catch (_error) {
      text = '';
    }

    const rating = text.match(/([0-5](?:\.\d)?)\s*\/\s*5/i);
    const count = text.match(/([\d,]+)\s+reviews?\b/i);
    if (rating) {
      document.querySelectorAll('[data-mf-review-rating]').forEach((element) => {
        element.textContent = rating[1];
      });
    }
    if (count) {
      document.querySelectorAll('[data-mf-review-count]').forEach((element) => {
        element.textContent = `· ${count[1]} reviews`;
      });
    }

    if ((!rating || !count) && attempts < 40) window.setTimeout(sync, 500);
  };
  sync();
}

// Expose so each interactive section can self-initialise its own controls
// (scoped, idempotent) when added/reordered in the theme editor.
window.initializeMifoa = initializeMifoa;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeMifoa());
} else {
  initializeMifoa();
}

document.addEventListener('shopify:section:load', (event) => initializeMifoa(event.target));
